export default {
    "en": {
        "about": {
            "greetingTitle": "Hi,",
            "continueTitle": "we're your ticket to the world of crypto and AI",
            "descriptionTitle": "Learn new skills with our courses created by industry experts and taught by AI bloggers!",
            "startLearningBtn": "Start learning",
            "whatDuoSchool": "What's",
            "whatDuoSchoolName": "DuoSchool?",
            "duoSchoolDescriptionTitle1": "We are an online school that offers courses focused on cryptocurrencies and artificial intelligence.",
            "duoSchoolDescription1": "Our educational programs are tailored to students' needs and range from beginner to advanced: you can start your journey from the basics and go up to complex trading strategies.",
            "duoSchoolDescription2": "To help people learn more effectively, we use an interactive approach that includes theory, practice, bonuses, and a referral program. The bonuses can be later exchanged for exclusive rewards. At the end of each course, successful students get certificates of completion.",
            "duoSchoolDescriptionTitle2": "Our goal",
            "duoSchoolDescription3": "Cryptocurrencies and AI are slowly but surely taking over the world. We want to teach people how to use them and help to become more financially literate.",
            "panelTitle": "Ready to learn something new?",
            "panelDescription": "Select a course and set off on your journey!",
            "whyTitle": "Why DuoSchool?",
            "panelBtn": "Choose a course"
        },
        "auth": {
            "divider": "or",
            "google": "Google",
            "apple": "Apple",
            "facebook": "Facebook",
            "loginTitle": "Log in",
            "loginDescription": "Enter your details bellow to log in",
            "loginLabelName": "Email / username",
            "loginLabelPassword": "Password",
            "loginPlaceholderName": "Enter your email / username",
            "loginPlaceholderPassword": "Enter your password",
            "loginForgotPassword": "Forgot password?",
            "loginAccount": "Don't have an account?",
            "loginCreate": "Create",
            "loginDenied": "You can not login right now",
            "nextBtn": "Continue",
            "prevBtn": "Previous step",
            "create": "Create an account",
            "haveAccount": "Already have an account?",
            "login": "Log In",
            "regTitle": "New account",
            "regDescription": "Enter your details bellow to create an account",
            "termsText": "I agree to the",
            "termsLink": "Terms and Conditions",
            "bloggerTitle": "Blogger selection",
            "bloggerDescription": "Choose a blogger to teach your courses",
            "bloggerSuggestion": "Magic suggestion",
            "pwStrWeak": "Weak",
            "pwStrMedium": "Medium",
            "pwStrStrong": "Strong",
            "pwStrVStrong": "Very Strong",
            "pwStrEmpty": "No Password",
            "labelName": "Full Name",
            "labelUsername": "Username",
            "labelEmail": "Email",
            "labelPhone": "Phone number",
            "labelTelegram": "Telegram username",
            "labelTelegramOpt": "Optional",
            "labelTelegramDesc": "Receive coins in the telegram game and transfer them to your DuoCrypto balance to purchase courses.",
            "labelPassword": "Password",
            "labelPasswordConfirmation": "Confirm Passwords",
            "labelPasswordDesc": "Password must be at least 8 characters long",
            "labelGender": "Gender",
            "labelBirthday": "Date of Birth",
            "labelCountry": "Country",
            "labelCity": "City",
            "placeholderName": "Enter your full name",
            "placeholderUsername": "Enter your username",
            "placeholderEmail": "Enter your email",
            "placeholderPhone": "Enter your phone number",
            "placeholderTelegram": "Username",
            "placeholderPassword": "Enter your password",
            "placeholderPasswordConfirmation": "Enter your password",
            "placeholderGender": "Select your gender",
            "placeholderBirthday": "00 - 00 - 0000",
            "placeholderCountry": "Your country",
            "placeholderCity": "Your city",
            "errName": "Full Name is required",
            "errName2": "Name can contain only A-Z letters, numbers.",
            "errNameLength": "The field must be between 3 and 16 characters.",
            "errUsername": "Username is required",
            "errUsername2": "Username can contain only A-Z letters, numbers, and underscores.",
            "errUsernameLength": "The field must be between 3 and 16 characters.",
            "errEmail": "Email is required",
            "errEmail2": "Email must be valid",
            "errEmail3": "Email must be valid.",
            "errEmail4": "Email can not be empty.",
            "errPhone": "Phone number is required",
            "errPhoneInvalid": "Phone number is invalid",
            "errPassword": "Password is required",
            "errPasswordShort": "Password must be at least 8 characters",
            "errPassword2": "Password must contain at least one capital letter and number.",
            "errPasswordConfirmation": "Passwords do not match",
            "errGender": "Gender is required",
            "errBirthday": "Birthday is required",
            "errInvalidBirthday": "Your birthday date format is incorrect, please adjust it",
            "errFutureBirthday": "Your birthday date is incorrect, please enter the correct date",
            "errCountry": "Country is required",
            "errCity": "City is required",
            "errTerms": "You must agree to the terms",
            "confirmPwdTitle": "Confirm password",
            "confirmPwdText": "Please confirm your password before continuing",
            "confirmPwdLabel": "Password",
            "confirmPwdPlaceholder": "Enter your password",
            "confirmPwdBtn": "Confirm",
            "verifyEmailTitle": "Confirm your email",
            "verifyMsg": "We have sent a verification link to",
            "verifyComplete": "Click on the link to complete the verification process.",
            "verifyComplete1": "You might need to check your spam folder.",
            "verifyCodeSend": "Resend code",
            "forgotPwdTitle": "Forgot password?",
            "forgotPwdText": "Enter your email so we can send to you link to password reset",
            "forgotPwdLabel": "Email",
            "forgotPwdPlaceholder": "Enter your email",
            "forgotPwdReset": "Password Reset",
            "forgotPwdLogin": "Back to log in",
            "resetEmailLabel": "Email",
            "resetPwdLabel": "Password",
            "resetConfirmPwdLabel": "Confirm Password",
            "resetEmailPlaceholder": "Enter your email",
            "resetPwdPlaceholder": "Enter your password",
            "resetConfirmPwdPlaceholder": "Enter your password",
            "resetPwdReset": "Update my password",
            "resetPwdLogin": "Back to log in",
            "upMenuProfile": "Profile",
            "upMenuNotifications": "Notifications",
            "upUpdated": "Your settings are saved",
            "usRemovePhoto": "Remove Photo",
            "usUnverified": "Your email address is unverified.",
            "usUnverifiedReSend": "Click here to re-send the verification email.",
            "usUnverifiedLink": "A new verification link has been sent to your email address.",
            "usSave": "Save",
            "usPlayGame": "Play Game",
            "unTitle": "Notification and Motivation",
            "unMotivationTitle": "Motivational messages",
            "unMotivationText": "These messages will be send to your email to remind you to complete the course",
            "unBonusTitle": "Notification of achievements, bonuses",
            "unBonusText": "When you receive bonuses, you will receive a notification by email",
            "unNewsTitle": "Platform news and new courses",
            "Gender": {
                "MALE": "Male",
                "FEMALE": "Female",
                "ALL": "Other",
                "UNKNOWN": "Not Set"
            }
        },
        "checkout": {
            "pmTitle": "Choose payment method",
            "pmDescription": "Please select your payment method now, as you won't be able to change it during checkout.",
            "pmMoneyTitle": "Pay using dollars",
            "pmMoneyDescription": "You can pay for the course using regular methods, but don't forget that you have the opportunity to",
            "pmCoinTitle": "Pay using platform coin",
            "pmCoinDescription": "You have the option to pay for the course entirely using platform credits. Below, you will see the total cost.",
            "pmCoinBalanceDescription": "Amount for be paid in Platform coin:",
            "pmCoinBalance": "Balance",
            "pmDiscount": "Calculate discount",
            "pmChoose": "Choose",
            "cpTitle": "Checkout",
            "cpDesc": "Enter your details bellow to buy course",
            "cpBilling": "Billing information",
            "cpPayment": "Payment methods",
            "cpPay": "Pay",
            "cpLabelName": "Full Name",
            "cpPlaceholderName": "Enter your full name",
            "cpLabelCountry": "Country",
            "cpPlaceholderCountry": "Your country",
            "termsText": "I agree to the",
            "termsLink": "Terms and Conditions",
            "cardTitle": "Credit Card",
            "coins": "Coins",
            "pcTitle": "Promo code",
            "pcPlaceholder": "Add Promo code",
            "pcButton": "Apply",
            "pcButtonSuccess": "Success",
            "ciTitle": "Your Course",
            "ciIncludesTitle": "Includes:",
            "ciIncludesDesc": "Access to course for",
            "ciSubtotal": "Subtotal:",
            "ciDiscount": "Discount:",
            "ciTotal": "Grand total:",
            "ciInfo": "Your access to the course is paid for a specific period. If you do not complete the course in that time, you can extend your access by selecting one of the available extension options."
        },
        "courses": {
            "learnMore": "Learn more",
            "showMore": "Show more",
            "loading": "Loading...",
            "coming": "Coming soon...",
            "button": "Buy now",
            "topSliderButton": "Buy now",
            "coursesTop": "Top Courses",
            "coursesBannerTitle1": "Profitable packages for you",
            "coursesBannerTitle2": "Discounts on courses",
            "coursesBannerTitle3": "Buy courses with platform coins to resell",
            "coursesBannerLink": "Learn more",
            "courseStudents": "Students",
            "courseLanguage": "Language",
            "courseMultilingual": "Multilingual",
            "courseCertificate": "Certificate",
            "courseAvailable": "Available",
            "courseNotAvailable": "Not Available",
            "courseLessons": "Lessons",
            "courseDuration": "Duration",
            "courseDifficulty": "Difficulty",
            "courseTagsTitle": "Skills you'll gain",
            "courseLessonTitle": "Lessons",
            "courseContentTitle": "More details",
            "courseSliderTitle": "People also buy",
            "courseDiscount": "Discount calculator",
            "courseDiscountText": "Write how many platform coins you are ready to spend and we will calculate the discount for you",
            "courseDiscountMax": "Maximum amount that can be spent:",
            "courseDiscountBalance": "Your balance:",
            "courseDiscountDiscount": "Your discount:",
            "courseDiscountUse": "Use discount",
            "courseDiscountLater": "Later",
            "courseDiscountLogin": "Log in to use discount",
            "courseDiscountQuantity": "Select quantity:",
            "courseDiscountCoins": "Coins",
            "courseDiscountCoin": "Coins",
            "courseBuy": "Buy a course",
            "courseBuyDesc": "Your access to the course is paid for a 3 months. If you do not complete the course in that time, you can extend your access by selecting one of the available extension options.",
            "coursePlatformTitle": "Use platform coins when purchasing a course",
            "coursePlatformDesc": "You can use the earned coins to form a discount or to pay the course in full",
            "lsTheory": "Theory",
            "lsPractice": "Practice",
            "lsTest": "Test",
            "lsLearned": "Theory learned",
            "lsTestDone": "Test done",
            "lsTestPassed": "Test Passed",
            "lsPracticeDone": "Practice done",
            "lsPracticePassed": "Practice Complete",
            "lsPracticeLocked": "You have to watch video to the end and click \"Theory learned\" button to access the practice and then next lessons...",
            "lsPracticeDoneHint": "This button activates once you complete the test or browse though all practice slides. Click it to gain access to the next lesson.",
            "lsLessonsLocked": "Each lesson is accessible only after completing the previous one",
            "lsTheoryError": "You must see video full time",
            "lsModalTitle": "Good Job!",
            "lsModalDesc": "Keep up the great work and collect even more rewards!",
            "lsModalContent": "You’ve completed the lesson and earned:",
            "lrpPurchased": "Recently purchased",
            "lrpStartBtn": "Start Course",
            "lrpShareBtn": "Share",
            "lrpProgress": "In Progress",
            "lrpStudies": "Last studies",
            "lrpCompleted": "Completed",
            "lrpLessons": "Lessons",
            "lrpCourseBtn": "To Course",
            "lrpLessonsTitle": "Last studies",
            "lrpDescLessons": "Lessons:",
            "lrpValidPeriod": "Course is valid until:",
            "lrpExtendPeriod": "Extend",
            "lrpDescSpent": "Spent:",
            "lrpDescTime": "Time:",
            "lrpDescTimePoint": "h",
            "lrpCoinsPoint": "up to +",
            "lrpDescType": "Type:",
            "lrpDescXp": "XP:",
            "lrpDescCoins": "Coins:",
            "lrpDescBtn": "Continue",
            "lrpDescBtnFinal": "Passed",
            "lrpSertificate": "View certificate",
            "lrpSertModalTitle": "Certificate of completion",
            "lrpSertModalDesc": "You can download the certificate of completion of the course at any time.",
            "lrpSertModalDownload": "Download",
            "lrpSertModalShare": "Share",
            "lrpCpProgress": "Progress",
            "lrpCpLessons": "Your lessons",
            "extendTitle": "Course extend",
            "extendDesc": "You can extend the course for a certain period if you do not have time to complete it.",
            "extendPeriod": "Choose period",
            "extendAmount": "Amount to be paid",
            "extendClose": "Later",
            "extendContinue": "Go to the payment",
            "expiredTitle": "Access Expired",
            "expiredText": "Unfortunately, your access to this course has expired. You can extend it by choosing a desired duration and paying the corresponding amount. Please select the extension period to continue your learning!",
            "expiredButton": "Extend",
            "tgTitle": "Want to pay <span class=\"text-grayscale-900\">less</span> ?",
            "tgDesc": "Earn coins in our GraphDEX Telegram game and exchange them for a course or get a discount. <br><br>To transfer your earned coins to DuoSchool, simply connect your Telegram account through the Settings section on our platform.",
            "tgBtn": "Go to Telegram",
            "qquiz": "Quiz",
            "qduration": "Duration",
            "qquestions": "correct answers",
            "qcorrect": "Correct answer",
            "qcheck": "Check",
            "qcontinue": "Continue",
            "qgotit": "Got it",
            "qback": "Back to theory",
            "qdone": "Test done",
            "qserverError": "Server Error",
            "psmTitle": "Proceed to the platform",
            "psmDesc": "Please proceed to the platform to apply the information you've learned. Only after completing this step will you be able to move to the next slide.",
            "psmBtn": "Practice in action",
            "psmClose": "Close",
            "practice": "Practice",
            "test": "Test",
            "min": "m",
            "ok": "OK",
            "psmCompleateDesc": "You have successfuly completed the practice",
            "Difficulty": {
                "BEGINNER": "Beginners",
                "MEDIUM": "Medium",
                "HARD": "Hard",
                "EXPERT": "Expert"
            },
            "ProlongPeriod": {
                "ONE_MONTH": "1 month",
                "TWO_MONTH": "2 months",
                "TREE_MONTH": "3 months",
                "UNLIMITED": "Unlimited"
            },
            "start": "START",
            "finish": "FINISH",
            "lrpShareModalTitle": "Share course",
            "lrpShareModalCopy": "Copy promocode",
            "lrpShareModalCopySuccess": "Link copied",
            "lrpShareModalText01": "You can copy the link with promocode and share it with someone you'd like to gift the course to. Here's how it works:",
            "lrpShareModalText02": "Copy the link with promo code.",
            "lrpShareModalText03": "Share the link with the person you want to gift the course to.",
            "lrpShareModalText04": "The recipient can use the link after logging in to the Platform",
            "lrpShareModalText05": "Once the link is used, we'll send you a notification confirming the you've successfully shared your course!",
            "lrpShareModalLabel": "Promocode",
            "errorMsgAlreadyActivated": "This link is invalid or has already been activated.",
            "errrorMsgTitle": "Error"
        },
        "emails": {
            "verify_email_subject": "Verify Email Address",
            "verify_email_line": "Please click the button below to verify your email address.",
            "verify_email_action": "Verify Email Address",
            "verify_email_no_action": "If you did not create an account, no further action is required.",
            "all_rights": "All rights reserved.",
            "reset_password_subject": "Reset Password Notification!!!",
            "reset_password_line": "You are receiving this email because we received a password reset request for your account.",
            "reset_password_action": "Reset Password",
            "reset_password_expiry": "This password reset link will expire in {count} minutes.",
            "reset_password_no_action": "If you did not request a password reset, no further action is required.",
            "greeting": {
                "default": "Hello!",
                "error": "Whoops!"
            },
            "regards": "Regards",
            "subcopy": "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser:",
            "expired": "Course access expiration notification!",
            "prolongation": "The course prolongation purchase!"
        },
        "global": {
            "Today": "Today",
            "Yesterday": "Yesterday",
            "PromoCodeHasBeenActivated": "Promo code has been activated",
            "ThePromoCodeWasApplied": "The promo code {promo_code} was applied.",
            "ContinueLearning": "Continue learning",
            "langTitle": "Choose your language",
            "langError": "This language is not support.",
            "langWarning": "",
            "home": "Home",
            "learning": "Learning",
            "ranks": "Top",
            "shop": "Shop",
            "courses": "Courses",
            "referral": "Referral",
            "settings": "Settings",
            "help": "Help",
            "logout": "Log out",
            "profile": "Profile",
            "btDashboard": "Dashboard",
            "btHelp": "Help",
            "btTokens": "API Tokens",
            "btCheckoutError": "Checkout Error",
            "btCheckoutSuccess": "Checkout Success",
            "btCourses": "Courses",
            "btCourse": "Course",
            "btLeaderboard": "Leaderboard",
            "btLearningCourse": "Learning Course",
            "btLearning": "Learning",
            "btLesson": "Lesson",
            "btShop": "Shop",
            "btCertificate": "Certificate",
            "btReferrals": "My referrals",
            "btProfile": "Profile",
            "btPrivacy": "Privacy Policy",
            "btTerms": "Terms and Conditions",
            "btCookie": "Cookies Policy",
            "ncTitle": "You currently have no purchased courses",
            "ncText": "Unfortunately, you currently have no purchased courses, so there is no available content here. Please acquire a course, and you'll be able to access the relevant information on this page.",
            "ncButton": "View courses",
            "ibTitle": "Start the race",
            "ibText": "Earn coins",
            "ibLink": "Race",
            "tabMenuJourney": "Journey",
            "tabMenuCourses": "Top courses",
            "tabMenuNews": "News",
            "title": "Your journey in",
            "level": "Level",
            "coursesTitle": "Top courses",
            "newsTitle": "Learn more about us",
            "pShareArticle": "Share Article",
            "pSimilarArticle": "Similar Articles",
            "refTitle": "My referrals",
            "refTitleTransactions": "My referrals transactions",
            "refTableName": "Referral",
            "refTableBonus": "Bonus",
            "refTableDate": "Date",
            "refInviteTitle": "Invite a friend",
            "refInviteText": "Get <strong class=\"text-white font-bold\">10%</strong> from your friends ",
            "refInviteLink": "Copy your referral link",
            "refInviteCopySuccess": "Copied",
            "refInviteCopyError": "Failed to copy",
            "refInviteOr": "or",
            "refInviteButton": "Show QR",
            "refInviteBalance": "Balance from referral purchases",
            "refInviteBalanceBtn": "Withdraw",
            "refModalTitle": "QR code",
            "refModalDownload": "Download QR",
            "refModalClose": "Close",
            "pagItems": "Items {from} - {to} of {total}",
            "pagShow": "Show:",
            "topMenuDaily": "Daily",
            "topMenuWeekly": "Weekly",
            "topMenuMonthly": "Monthly",
            "topStatHave": "You have",
            "topStatHaveBtn": "Continue learning",
            "topStatRank": "Your Rank",
            "topStatRankBtn": "View in leaderboard",
            "topTableSearch": "Search by name",
            "topTableRank": "Rank",
            "topTableName": "Name",
            "topTableCompleted": "Completed lessons",
            "topTableWin": "Entry win",
            "topTableTotal": "Total XP",
            "pfCoin": "coins",
            "pfCoinLink": "To Courses",
            "pfXpLink": "Leaderboard",
            "pfOverview": "Overview",
            "pfOverAttendance": "Attendance",
            "pfOverAttendanceDays": "days",
            "pfOverCourses": "Courses",
            "pfOverCoursesDone": "done",
            "pfAttendanceTitle": "Attendance",
            "pfAttendanceDesc": "Claim daily rewards. If you skip a day, your progress will reset.",
            "pfAttendanceDay": "Day",
            "carModalTitle": "You're crushing it!",
            "carModalDesc": "Keep up the great work!",
            "carModalPrize": "Here's your prize:",
            "fAbout": "About us",
            "fPrivacy": "Privacy Policy",
            "fAgreement": "Terms & Conditions",
            "fCookie": "Cookies Policy",
            "fCopy": "All Rights Reserved. DuoSchool.ai",
            "bePromoNotFound": "Promo code not found",
            "bePromoMissing": "Promo code nominal missing.",
            "bePromoExpired": "Promo code has expired.",
            "bePromoCourse": "Promo code can be applied to course only.",
            "bePromoCourseDenied": "Promo code cannot be applied to this course.",
            "bePromoCourseProlong": "Promo code cannot be applied to course prolongation.",
            "beOrderItem": "The item not found",
            "beOrderUser": "The user not found",
            "beCoinsOrder": "Insufficient coins for this order.",
            "beCheckoutEmpty": "Cart is empty",
            "beCheckoutOrder": "Order not found",
            "beCheckoutMissing": "Missing reason of failed payment attempt.",
            "beCourseNotFound": "Course not found",
            "beCourseStarted": "The course has already been started.",
            "beCourseNotStarted": "We can't start the course without lessons.",
            "beCourseCoursePlan": "Can not buy course plan now",
            "beCartAdd": "Can't add product to cart",
            "beCartPayment": "Can't get payment methods",
            "beCartEmpty": "Your cart is empty.",
            "beCartMissingPM": "Missing payment method",
            "beCartCreateSession": "Can't create checkout session",
            "beCartPromoMissed": "Missing promo code",
            "beCartPromoUsed": "Promo code already used",
            "beLearningCourse": "Missing user course.",
            "beLearningStart": "We can't start this course now, please contact the support team.",
            "beLessonView": "You can't view this lesson.",
            "beLessonSlideId": "Missing slide id",
            "beLessonSlideProcess": "Can't process gallery slide.",
            "beLessonAnswerCheck": "Can't check the question answer.",
            "beLessonTheoryFail": "Can't complete the theory, please try again or contact the support team.",
            "beLessonPracticeFail": "Can't complete the practice, please try again or contact the support team.",
            "dailyModalTitle": "Earnings update",
            "dailyModalDesc": "You've earned for logging in on your {day} consecutive day! Keep it going for even more rewards!",
            "dailyModalPrize": "Here's your prize:",
            "portugal": "Portugal",
            "leaderBoardPeriod": "The leaderboard is updated every hour.",
            "certTitle": "Certificate of Completion",
            "certDesc": "This certifies that student has successfully completed the",
            "certDesc2": "course.",
            "headerNotify": "Add your full name to your profile for accurate certificates.",
            "headerNotifyLink": "Edit profile",
            "helpBannerTitle": "Didn’t find an answer?",
            "helpBannerDesc": "Write us your question in any convenient platform. We will answer you as soon as possible",
            "HelpTopics": {
                "ALL": "All",
                "SETTINGS": "Profile",
                "PLATFORM": "Courses",
                "AI": "About the project",
                "FAQ": "Frequently Asked Questions"
            }
        },
        "lp": {
            "navCourse": "Course",
            "navAbout": "About us",
            "navNews": "Blog",
            "login": "Login",
            "register": "Start now",
            "subscribe": "Subscribe for our newsletter",
            "emailPalceholder": "Email",
            "navigation": "Navigation",
            "policies": "Policies",
            "courses": "Courses",
            "about": "About us",
            "news": "News",
            "cookie": "Cookies Policy",
            "privacy": "Privacy Policy",
            "agreement": "Terms & Conditions",
            "contacts": "Contact us",
            "copy": "© 2025 — DuoSchool",
            "courseTitle": "Top Courses",
            "courseBuy": "Buy now",
            "bTitle": "Learn new <span class=\"text-primary-500\">skills</span> with your favourite bloggers and experts",
            "bText": "We have collected the best educational programs about AI and crypto tailored to your needs in one place. Receive certifications, share your learning experience, earn rewards, and enjoy our referral program.",
            "bButton": "How does it work?",
            "lpNotes": "AI & Crypto Courses",
            "lpWidget": "Build-in widgets for practice",
            "lpCursor": "Interactive learning",
            "lpSale": "Bonus points for achievements",
            "lpCup": "Motivational leaderboard",
            "lpGamepad": "Random Bonus Game",
            "mTitle": "Master the most valuable AI & crypto skills",
            "mTitle1": "Cryptocurrency",
            "mText1": "Blockchain and crypto changed the way we think about finance. As the crypto space continues to grow, understanding its nuances is crucial for modern people. Start our courses to learn about the basics of crypto and continue with more complex programs about trading on CEXs, DEXs, meme coins, and retrodrops.",
            "mBtn1": "Choose a course",
            "mTitle2": "Artificial Intelligence",
            "mText2": "Understanding AI is no longer optional; it's essential for staying ahead in today’s tech-driven world. With our courses, you can start from the basics and then dive into specialized topics of AI videos, images, and texts. Our artificial intelligence courses are held by AI-generated experts.",
            "mBtn2": "Choose a course",
            "sTitle": "The student's favourite",
            "sBlockTitle": "Starter",
            "sBlockText": "Our course will immerse you in the world of cryptocurrencies and blockchain from the ground up, helping you not only study theory but also gain real practical experience. We start with the basics: you’ll learn what cryptocurrencies are, how they work, their role in the modern economy, and why they are considered the future of finance.",
            "sBlockPrimaryBtn": "Start now",
            "sBlockSecondaryBtn": "Learn more",
            "jTitle": "Your learning journey",
            "jTabTitle1": "Theoretical Part",
            "jTabContent1": "Learn with our easy-to-understand video lessons that build a strong foundation.",
            "jTabTitle2": "Practical Part",
            "jTabContent2": "Apply your new skills in hands-on activities and real-world scenarios.",
            "jTabTitle3": "Earning Bonuses",
            "jTabContent3": "Earn rewards as you progress, with bonuses for completing tasks and hitting milestones.",
            "jTabTitle4": "Spending Coins",
            "jTabContent4": "Use the coins you’ve earned to unlock exclusive rewards.",
            "tTitle": "",
            "tText": "Want to learn on great terms? Visit our partners' bot to receive the course. Don't miss this exclusive offer.",
            "tBtn": "Go to Telegram",
            "lTitle1": "Save money with our course bundles",
            "lText1": "Dive into the world of cryptocurrencies and AI at a fraction of the price",
            "lTitle2": "Earn with our referral program",
            "lText2": "Invite friends to study on our platform and receive cashback!",
            "lTitle3": "Unlock discounts with coins!",
            "lText3": "Use your platform coins to save on courses.",
            "lMore": "Learn more",
            "cTitle": "Why should you choose our courses ?",
            "cText": "We combine theory, practice, and a captivating reward system to make sure you gain useful skills for your next AI and crypto challenges.",
            "cBtn": "Choose a course",
            "cTitle1": "Multiple languages",
            "cText1": "Choose any language and study without the need to translate everything.",
            "cTitle2": "AI experts",
            "cText2": "Our virtual AI experts will show you how to become a pro at crypto and AI",
            "cTitle3": "Referral program",
            "cText3": "Earn bonuses for inviting your friends to the platform and exchange them for cool rewards.",
            "cTitle4": "Practical part",
            "cText4": "Theory is important, but we will show you how to put your newly acquired knowledge into practice.",
            "cTitle5": "Comprehensive courses",
            "cText5": "We offer the best AI and crypto lessons, combining our expertise with top educational practices",
            "aTitle": "Frequently Asked Questions",
            "oTitle": "Have more questions?",
            "oText": "If you have more questions, just send a message. We are here to help you succeed.",
            "oBtn": "Contact us",
            "aQuestion1": "Are the courses suitable for beginners, or do I need prior knowledge?",
            "aAnswer1": "Our courses are beginner-friendly. You can start from the basics and work your way up to more advanced topics.",
            "aQuestion2": "How do I earn and use bonuses and coins on the platform?",
            "aAnswer2": "You can receive bonuses for completing various tasks and hitting milestones. The bonuses can be later exchanged for discounts, rewards, upgrades in our game, etc.",
            "aQuestion3": "What kind of certification will I receive upon completing a course?",
            "aAnswer3": "You will receive a digital certificate of completion.",
            "aQuestion4": "How do I participate in the referral program and what are the benefits?",
            "aAnswer4": "Our referral program allows you to receive 10% of the amount your friends spend on courses. Invite friends and use your bonuses as you wish!",
            "aQuestion5": "Can I access the educational materials after completing the course?",
            "aAnswer5": "Yes, the educational materials are available for some time after completing the course. To prolong this period, you need to pay an additional fee.",
            "newsTitle": "Check out the Latest from Our Blog",
            "newsMore": "Read more",
            "newPreheader": "We uphold international law and ethical business practices by refraining from any collaboration with nations that engage in aggressive behavior.",
            "newBannerExtraTitle": "DuoSchool",
            "newBannerTitle": "your gateway to the next-gen of learning",
            "newBannerCheck01": "Taught by AI",
            "newBannerCheck02": "Loved by everybody",
            "newBannerBtnStart": "Start now for free",
            "newBannerBtnLearn": "Learn more",
            "partnersTitle": "These companies",
            "partnersExtraTitle": "work with us",
            "partnersText1": "is the top player in the crypto world with over <span class=\"text-accent\">250 million users in 180+ countries</span>",
            "partnersText2": "is a leading digital asset exchange, trusted by over <span class=\"text-accent\">30 million users in more than 170 countries and regions</span>",
            "partnersText3": "is an innovative MEV-focused company, with a proven track record of over <span class=\"text-accent\">150 token launches</span> and integrations across more than 100 DEXs and CEXs.",
            "partnersText4": "is a charting platform with market-analysis tools and a social network of over <span class=\"text-accent\">50 million traders</span> and investors.",
            "partnersText5": "is a leading analytics platform that <span class=\"text-accent\">provides real-time data</span> and insights into the <span class=\"text-accent\">DeFi landscape</span>.",
            "partnersText6": "is the second-largest crypto exchange by trading volume, with a massive community of over <span class=\"text-accent\">60 million users</span> around the globe",
            "countdownTitle": "Unlock Crypto Savings",
            "countdownText": "Subscribe to our Telegram bot and get an exclusive discount on crypto courses!",
            "countdownBtn": "Get discount",
            "countdownDay": "d",
            "countdownHour": "h",
            "countdownMin": "m",
            "countdownSec": "s",
            "perfectCoursesTitle": "Our courses are perfect for",
            "perfectCoursesItemTitle1": "Beginners who want to jump into crypto and AI",
            "perfectCoursesItemText1": "Think it’s too complicated? Not with us! We’ll help you learn the basics, show you how to make your first profit, and keep you from making the common mistakes.",
            "perfectCoursesItemTitle2": "Those who want sharpen their skills",
            "perfectCoursesItemText2": "Master advanced strategies in crypto trading and AI that help you consistently earn up to $2000 and gain the confidence to thrive in both rapidly evolving markets.",
            "perfectCoursesItemTitle3": "Those who want to stay ahead of the trends",
            "perfectCoursesItemText3": "Unlock the high-demand skills in blockchain and AI that open up exciting new opportunities. Start earning up to $3000 and watch your potential grow exponentially—no limits!",
            "perfectCoursesItemBtn": "View course",
            "certificationTitle": "Certification awaits!",
            "certificationText": "Finish the course and validate your expertise",
            "certificationBtn": "Find a course",
            "leaderboardTitle": "Climb the leaderboard and get our exclusive bonuses!",
            "leaderboardText": "Every week and month, the top 3 students get special rewards. For example:",
            "leaderboardBtn": "More Details",
            "leaderboardBlockTitle1": "Earn with our referral program",
            "leaderboardBlockText1": "Invite friends to study on our platform and receive cashback!",
            "leaderboardBlockTitle2": "Unlock discounts with coins!",
            "leaderboardBlockText2": "Use your platform coins to save on courses.",
            "pTestimonialTitle": "Expert support and webinars from:",
            "pTestimonialText1": "Alex, the founder and CEO of Peanut Trade, has over a decade of IT experience and has been immersed in the blockchain space since 2013.",
            "pTestimonialText2": "He participated in the Ethereum ICO and, in 2014, launched BitX, a startup that enabled people to pay for telecom and other everyday services with bitcoins. Alex also mined Bitcoin since 2015 and participated in the creation of Ukrainian miners’ Hotmine on Bitfury chips.",
            "pTestimonialText3": "Alex has successfully raised over $30 million for three projects: Remme, Hackless, and Peanut Trade. Since 2015, he has been involved in Bitcoin mining and serves as a Board Member of the Bitcoin Foundation Ukraine.",
            "pTestimonialText4": "Additionally, he is a member of the working group preparing cryptocurrency legislation in Ukraine.",
            "pTestimonialName": "Alex Momot",
            "pTestimonialJob": "Founder & CEO at Peanut Trade",
            "opTitle": "Discover amazing study opportunities!",
            "opBtn": "Start now for free",
            "opContentTitleB1": "Flexibility",
            "opContentB1Text1": "Structured courses - Theory & Practice",
            "opContentB1Text2": "Opportunity to learn at your pace - Anytime, Anywhere",
            "opContentB1Text3": "Select your preferred language",
            "opContentB1Text4": "No experience required, beginner-friendly",
            "opContentB1Text5": "Access to the Discord channel",
            "opContentTitleB2": "Support",
            "opContentB2Text1": "24/7 doubt-clearing sessions with AI agents",
            "opContentB2Text2": "Mentor support",
            "opContentB2Text3": "Regular webinars and AMA sessions with experts",
            "opContentTitleB3": "Community",
            "opContentB3Text1": "Friendly international community",
            "opContentB3Text2": "Leaderboard and games on the platform",
            "opContentB3Text3": "Unique NFTs for the best students",
            "opContentTitleB4": "Advanced Features",
            "opContentB4Text1": "Advanced trading strategies and analytics",
            "opContentB4Text2": "Bonuses and discounts for new courses",
            "opContentB4Text3": "Choose the language of your choice",
            "opContentB4Text4": "Certificate upon course completion",
            "opContentB4Text5": "Fantastic referral program",
            "studentsTitle": "students are already learning with us",
            "studentsBtn": "Start now for free",
            "catTitle": "Choose a course that fits your needs most",
            "catCouseTitle00": "Cryptocurrency for beginners",
            "catCouseTitle01": "Memecoin trading: from theory to practice",
            "catCouseTitle02": "Trading: from theory to practice",
            "catCouseTitle03": "Artificial intelligence for beginners",
            "catCouseTitle04": "Advanced AI - From Theory to Mastery",
            "catCouseTopicCrypto": "Crypto Course",
            "catCouseTopicTrading": "Trading Course",
            "catCouseTopicAi": "AI Course",
            "catCouseBtn": "Choose an option",
            "catCryptoTitle": "Crypto courses",
            "catAiTitle": "AI Courses",
            "lModalTitle": "Lessons",
            "tradingHeroTitle": "Trading: from theory to practice",
            "tradingHeroText1": "Trading might seem complicated at first, but trust us—it doesn’t have to be.",
            "tradingHeroText2": "In this course, we’ll start with the basics and build your skills step by step. You’ll get a solid mix of theory and hands-on experience, so you’re not just learning—you’re preparing to take action! By the end, you’ll feel way more confident navigating the financial markets, whether you're working with traditional assets or exploring the exciting world of cryptocurrencies.",
            "tradingHeroText3": "This course is perfect for complete beginners, those who’ve tried trading but aren’t sure where to go next, and anyone thinking about making trading a full-time career.",
            "tradingOptions": "Choose your option",
            "tradingOptionsReviews": "reviews",
            "tradingOptionsDuration": "Duration:",
            "tradingOptionsHour": "h",
            "tradingOptionsMinute": "min",
            "tradingOptionsExperts": "Experts:",
            "tradingOptionsExpertsName": "AI Alex & Emma",
            "tradingOptionsEarn": "Earn:",
            "tradingOptionsEarnTo": "Up to",
            "tradingOptionsIncluded": "What’s included",
            "tradingOptionsListBtn": "View lessons",
            "tradingOptionsBuy": "Buy now",
            "tradingOptionsTitle1": "Base",
            "tradingOptionsTitle2": "Middle",
            "tradingOptionsTitle3": "Pro",
            "tradingOptionsList01Item01": "Access to the course for 1 month",
            "tradingOptionsList01Item02": "27 lessons",
            "tradingOptionsList01Item03": "Participation in the leaderboard",
            "tradingOptionsList01Item04": "Basic support",
            "tradingOptionsList01Item05": "Free PDF materials",
            "tradingOptionsList02Item01": "Access to the course for 1 month",
            "tradingOptionsList02Item02": "All 54 lessons",
            "tradingOptionsList02Item03": "Participation in the leaderboard",
            "tradingOptionsList02Item04": "Basic support",
            "tradingOptionsList02Item05": "Free PDF materials",
            "tradingOptionsList02Item06": "Cerificate",
            "tradingOptionsList02Item07": "Free webinars",
            "tradingOptionsList02Item08": "1-month access to a private community",
            "tradingOptionsList02Item09": "AMA sessions",
            "tradingOptionsList03Item01": "Access to the course for 3 month",
            "tradingOptionsList03Item02": "All 54 lessons",
            "tradingOptionsList03Item03": "Participation in the leaderboard",
            "tradingOptionsList03Item04": "AI 24/7 support",
            "tradingOptionsList03Item05": "A set of PDF materials ",
            "tradingOptionsList03Item06": "Certificate",
            "tradingOptionsList03Item07": "Additional video materials released every 2 weeks",
            "tradingOptionsList03Item08": "3-month access to a private community",
            "tradingOptionsList03Item09": "Monthly AMA sessions with leading crypto figures",
            "tradingOptionsList03Item10": "Weekly AMA sessions with curators",
            "tradingOptionsList03Item11": "Unique NFT",
            "tradingOptionsList03Item12": "Job opportunities at leading global crypto companies.",
            "tradingOptionsList03Item13": "Access to beta versions of new tools and services",
            "tradingSureTitle": "Not sure if this course is right for you?",
            "tradingSureText": "Check out the lesson list, but to be absolutely sure, try a couple of lessons for FREE! See for yourself how valuable and convenient our course is before making your decision.",
            "tradingSureBtn": "Start for free",
            "tradingReviewTitle": "Get inspired",
            "tradingReviewText": "Learn how other students changed their careers and lives with the help of Duoschool",
            "tradingAlsoBuyTitle": "People also buy",
            "memeHeroTitle": "Memecoin trading: from theory to practice",
            "memeHeroText1": "Curious about the buzz surrounding memecoins? This course is your ticket to understanding this exciting niche in the crypto market!",
            "memeHeroText2": "You’ll learn how to analyze memecoins effectively, identify potential winners, and navigate the often unpredictable market dynamics.",
            "memeHeroText3": "Whether you’re a curious newcomer or someone looking to enhance your trading portfolio, this course offers valuable insights that could multiply your investment.",
            "memeOptionsList01Item01": "Access to the course for 1 month",
            "memeOptionsList01Item02": "27 lessons",
            "memeOptionsList01Item03": "Participation in the leaderboard",
            "memeOptionsList01Item04": "Basic support",
            "memeOptionsList01Item05": "Free PDF materials",
            "memeOptionsList02Item01": "Access to the course for 1 month",
            "memeOptionsList02Item02": "All 38 lessons",
            "memeOptionsList02Item03": "Participation in the leaderboard",
            "memeOptionsList02Item04": "Basic support",
            "memeOptionsList02Item05": "Free PDF materials",
            "memeOptionsList02Item06": "Cerificate",
            "memeOptionsList02Item07": "Free webinars",
            "memeOptionsList02Item08": "1-month access to a private community",
            "memeOptionsList02Item09": "AMA sessions",
            "memeOptionsList03Item01": "Access to the course for 3 month",
            "memeOptionsList03Item02": "All 38 lessons",
            "memeOptionsList03Item03": "Participation in the leaderboard",
            "memeOptionsList03Item04": "AI 24/7 support",
            "memeOptionsList03Item05": "A set of PDF materials ",
            "memeOptionsList03Item06": "Additional video materials released weekly",
            "memeOptionsList03Item07": "Certificate",
            "memeOptionsList03Item08": "3-month access to a private community",
            "memeOptionsList03Item09": "Monthly AMA sessions with leading crypto figures",
            "memeOptionsList03Item10": "Weekly AMA sessions with curators",
            "memeOptionsList03Item11": "Unique NFT",
            "memeOptionsList03Item12": "Job opportunities at leading global crypto companies.",
            "starterHeroTitle": "Cryptocurrency for beginners",
            "starterHeroText1": "If you’ve been hearing about crypto and blockchain but don’t know where to start, this course is made for you! We’ll break it all down—from the basics to practical insights—so you can fully understand how cryptocurrencies work and why they’re shaping the future of finance.",
            "starterHeroText2": "By the end, you’ll have a strong grasp of what crypto is, its role in the global economy, and why it’s so much more than just a trend.",
            "starterHeroText3": "This course is great for anyone wanting to finally understand the crypto landscape and explore the exciting earning opportunities that digital currencies offer.",
            "starterOptionsList01Item01": "Access to the course for 1 month",
            "starterOptionsList01Item02": "19 lessons",
            "starterOptionsList01Item03": "Participation in the leaderboard",
            "starterOptionsList01Item04": "Basic support",
            "starterOptionsList02Item01": "Access to the course for 3 month",
            "starterOptionsList02Item02": "19 lessons",
            "starterOptionsList02Item03": "Participation in the leaderboard",
            "starterOptionsList02Item04": "Personal 24/7 support",
            "starterOptionsList02Item05": "Certificate",
            "starterOptionsList02Item06": "A set of PDF materials ",
            "starterOptionsList02Item07": "Additional video materials released every 2 weeks",
            "starterOptionsList02Item08": "Opportunity to earn money",
            "beginerCourseDifficulty": "Medium",
            "beginerCourseTitle": "Starter",
            "beginerCourseType": "Trading Course",
            "beginerCourseBtn": "Choose an option",
            "tradeCourseDifficulty": "Hard",
            "tradeCourseTitle": "Trading",
            "tradeCourseType": "Trading Course",
            "tradeCourseBtn": "Choose an option",
            "memeCourseDifficulty": "Hard",
            "memeCourseTitle": "Memecoins",
            "memeCourseType": "Crypto Course",
            "memeCourseBtn": "Choose an option"
        }
    },
    "ru": {
        "about": {
            "greetingTitle": "Привет!",
            "continueTitle": "Мы — ваш билет в мир криптовалют и искусственного интеллекта",
            "descriptionTitle": "Осваивайте новые навыки с помощью наших курсов, созданных экспертами!",
            "startLearningBtn": "Начать обучение",
            "becomePartnerBtn": "Стать партнером",
            "whatDuoSchool": "Что такое",
            "whatDuoSchoolName": "DuoSchool?",
            "duoSchoolDescriptionTitle1": "Мы — онлайн-школа, которая предлагает курсы по криптовалютам и искусственному интеллекту.",
            "duoSchoolDescription1": "Наши образовательные программы адаптированы под потребности студентов и варьируются от начального до продвинутого уровня — например, вы можете начать свой путь с основ и перейти к сложным торговым стратегиям.",
            "duoSchoolDescription2": "Чтобы помочь студентам учиться более эффективно, мы используем интерактивный подход, включающий теорию, практику, бонусы и реферальную программу. Заработанные бонусы можно обменивать на эксклюзивные вознаграждения. В конце каждого курса студенты, успешно выполнившие все задания, получают сертификаты.",
            "duoSchoolDescriptionTitle2": "Наша цель",
            "duoSchoolDescription3": "Криптовалюты и ИИ медленно, но уверенно захватывают мир. Мы хотим научить людей пользоваться ими и помочь им стать более финансово грамотными.",
            "panelTitle": "Готовы выучить что-то новенькое?",
            "panelDescription": "Выберите подходящий курс и начните свой путь к успеху!",
            "whyTitle": "Почему DuoSchool?",
            "panelBtn": "Выбрать курс"
        },
        "auth": {
            "divider": "или",
            "google": "Google",
            "apple": "Apple",
            "facebook": "Facebook",
            "loginTitle": "Войти",
            "loginDescription": "Введите ваши данные ниже, чтобы войти",
            "loginLabelName": "Электронная почта / имя пользователя",
            "loginLabelPassword": "Пароль",
            "loginPlaceholderName": "Введите вашу электронную почту / имя пользователя",
            "loginPlaceholderPassword": "Введите ваш пароль",
            "loginForgotPassword": "Забыли пароль?",
            "loginAccount": "Нет аккаунта?",
            "loginCreate": "Создать",
            "loginDenied": "Вы не можете войти сейчас",
            "nextBtn": "Продолжить",
            "prevBtn": "Назад",
            "create": "Создать аккаунт",
            "haveAccount": "Уже есть аккаунт?",
            "login": "Войти",
            "regTitle": "Новый аккаунт",
            "regDescription": "Введите ваши данные ниже, чтобы создать аккаунт",
            "termsText": "Я согласен с",
            "termsLink": "Условиями и положениями",
            "bloggerTitle": "Выбор блогера",
            "bloggerDescription": "Выберите блогера для обучения вашим курсам",
            "bloggerSuggestion": "Магическая рекомендация",
            "pwStrWeak": "Слабый",
            "pwStrMedium": "Средний",
            "pwStrStrong": "Сильный",
            "pwStrVStrong": "Очень сильный",
            "pwStrEmpty": "Нет пароля",
            "labelName": "Полное имя",
            "labelUsername": "Имя пользователя",
            "labelEmail": "Электронная почта",
            "labelPhone": "Номер телефона",
            "labelTelegram": "Имя пользователя в Telegram",
            "labelTelegramOpt": "Опционально",
            "labelTelegramDesc": "Получайте монеты в телеграмм-игре и переводите их на баланс DuoCrypto для покупки курсов.",
            "labelPassword": "Пароль",
            "labelPasswordConfirmation": "Подтвердите пароль",
            "labelPasswordDesc": "Пароль должен содержать не менее 8 символов.",
            "labelGender": "Пол",
            "labelBirthday": "Дата рождения",
            "labelCountry": "Страна",
            "labelCity": "Город",
            "placeholderName": "Полное имя",
            "placeholderUsername": "Имя пользователя",
            "placeholderEmail": "Введите вашу электронную почту",
            "placeholderPhone": "Введите ваш номер телефона",
            "placeholderTelegram": "Имя пользователя",
            "placeholderPassword": "Введите ваш пароль",
            "placeholderPasswordConfirmation": "Введите ваш пароль",
            "placeholderGender": "Выберите ваш пол",
            "placeholderBirthday": "00 - 00 - 0000",
            "placeholderCountry": "Ваша страна",
            "placeholderCity": "Ваш город",
            "errName": "Полное имя обязательно",
            "errName2": "Имя пользователя может содержать только латинские буквы и цифры.",
            "errNameLength": "Поле должно содержать от 3 до 16 символов.",
            "errUsername": "Имя пользователя обязательно",
            "errUsername2": "Имя пользователя может содержать только латинские буквы, цифры и подчеркивания.",
            "errUsernameLength": "Поле должно содержать от 3 до 16 символов.",
            "errEmail": "Электронная почта обязательна",
            "errEmail2": "Электронная почта должна быть действительной",
            "errEmail3": "Электронная почта должна быть действительной",
            "errEmail4": "Электронная почта не может быть пустой",
            "errPhone": "Номер телефона обязателен",
            "errPhoneInvalid": "Неправильный номер телефона",
            "errPassword": "Пароль обязателен",
            "errPasswordShort": "Пароль должен содержать не менее 8 символов",
            "errPassword2": "Пароль должен содержать как минимум 1 большую букву и цифру.",
            "errPasswordConfirmation": "Пароли не совпадают",
            "errGender": "Пол обязателен",
            "errBirthday": "Дата рождения обязательна",
            "errInvalidBirthday": "Формат даты вашего дня рождения неверен, пожалуйста, исправьте его",
            "errFutureBirthday": "Дата вашего дня рождения неверна, пожалуйста, введите правильную дату",
            "errCountry": "Страна обязательна",
            "errCity": "Город обязателен",
            "errTerms": "Вы должны согласиться с условиями",
            "confirmPwdTitle": "Подтвердите пароль",
            "confirmPwdText": "Пожалуйста, подтвердите ваш пароль перед продолжением",
            "confirmPwdLabel": "Пароль",
            "confirmPwdPlaceholder": "Введите ваш пароль",
            "confirmPwdBtn": "Подтвердить",
            "verifyEmailTitle": "Подтвердите ваш email",
            "verifyMsg": "Мы отправили ссылку на",
            "verifyComplete": "Перейдите по ссылке для завершения проверки.",
            "verifyComplete1": "Вам может понадобиться проверить папку Spam.",
            "verifyCodeSend": "Отправить код заново",
            "forgotPwdTitle": "Забыли пароль?",
            "forgotPwdText": "Введите вашу электронную почту, чтобы мы могли отправить ссылку для сброса пароля",
            "forgotPwdLabel": "Электронная почта",
            "forgotPwdPlaceholder": "Введите вашу почту",
            "forgotPwdReset": "Сброс пароля",
            "forgotPwdLogin": "Назад ко входу",
            "resetEmailLabel": "Электронная почта",
            "resetPwdLabel": "Пароль",
            "resetConfirmPwdLabel": "Подтвердите пароль",
            "resetEmailPlaceholder": "Введите вашу почту",
            "resetPwdPlaceholder": "Введите ваш пароль",
            "resetConfirmPwdPlaceholder": "Введите ваш пароль",
            "resetPwdReset": "Обновить пароль",
            "resetPwdLogin": "Назад ко входу",
            "upMenuProfile": "Профиль",
            "upMenuNotifications": "Уведомления",
            "upUpdated": "Ваши настройки успешно изменены",
            "usRemovePhoto": "Удалить фото",
            "usUnverified": "Ваш адрес электронной почты не подтвержден.",
            "usUnverifiedReSend": "Нажмите здесь, чтобы повторно отправить письмо для подтверждения.",
            "usUnverifiedLink": "Новая ссылка для подтверждения была отправлена на ваш адрес электронной почты.",
            "usSave": "Сохранить",
            "usPlayGame": "Играть в Гонки",
            "unTitle": "Уведомления и Мотивация",
            "unMotivationTitle": "Мотивационные сообщения",
            "unMotivationText": "Эти сообщения будут отправляться на вашу электронную почту, чтобы напомнить вам завешить прохождения курса",
            "unBonusTitle": "Уведомления о достижениях, бонусах",
            "unBonusText": "Когда вы получите бонусы, вам прийдет сообщение об этом по электронной почте",
            "unNewsTitle": "Новости платформы и новые курсы",
            "failed": "Эти учетные данные не совпадают с нашими записями.",
            "password": "Указанный пароль неверен.",
            "throttle": "Слишком много попыток входа. Пожалуйста, попробуйте снова через {seconds} секунд.",
            "Gender": {
                "MALE": "Мужчина",
                "FEMALE": "Женщина",
                "ALL": "Другое",
                "UNKNOWN": "Не установлен"
            }
        },
        "checkout": {
            "pmTitle": "Выберите способ оплаты",
            "pmDescription": "Пожалуйста, выберите способ оплаты сейчас, так как вы не сможете изменить его во время оформления заказа.",
            "pmMoneyTitle": "Оплатить в долларах",
            "pmMoneyDescription": "Вы можете оплатить курс обычными способами, но не забывайте, что у вас есть возможность",
            "pmCoinTitle": "Оплатить монетами платформы",
            "pmCoinDescription": "У вас есть возможность полностью оплатить курс с помощью кредитов платформы. Ниже вы увидите общую стоимость.",
            "pmCoinBalanceDescription": "Сумма, подлежащая оплате в монетах платформы:",
            "pmCoinBalance": "Баланс",
            "pmDiscount": "Рассчитать скидку",
            "pmChoose": "Выбрать",
            "cpTitle": "Оформление заказа",
            "cpDesc": "Введите свои данные ниже для покупки курса",
            "cpBilling": "Платежная информация",
            "cpPayment": "Способы оплаты",
            "cpPay": "Оплатить",
            "cpLabelName": "Полное имя",
            "cpPlaceholderName": "Введите ваше полное имя",
            "cpLabelCountry": "Страна",
            "cpPlaceholderCountry": "Ваша страна",
            "termsText": "Я согласен с",
            "termsLink": "Условия использования",
            "cardTitle": "Кредитная карта",
            "coins": "Монетки",
            "pcTitle": "Промокод",
            "pcPlaceholder": "Добавить промокод",
            "pcButton": "Применить",
            "pcButtonSuccess": "Успешно",
            "ciTitle": "Ваш курс",
            "ciIncludesTitle": "Включает:",
            "ciIncludesDesc": "Доступ к курсу на",
            "ciSubtotal": "Промежуточный итог:",
            "ciDiscount": "Скидка:",
            "ciTotal": "Общая сумма:",
            "ciInfo": "Ваш доступ к курсу оплачен на определенный период. Если вы не завершите курс за это время, вы можете продлить доступ, выбрав один из доступных вариантов продления."
        },
        "courses": {
            "learnMore": "Узнать больше",
            "showMore": "Показать больше",
            "loading": "Загрузка...",
            "coming": "Скоро будет...",
            "button": "Купить сейчас",
            "topSliderButton": "Купить",
            "coursesTop": "Топ курсы",
            "coursesBannerTitle1": "Выгодные пакеты для вас",
            "coursesBannerTitle2": "Скидки на курсы",
            "coursesBannerTitle3": "Покупайте курсы за монеты платформы для перепродажи",
            "coursesBannerLink": "Узнать больше",
            "courseStudents": "Студенты",
            "courseLanguage": "Язык",
            "courseMultilingual": "Многоязычный",
            "courseCertificate": "Сертификат",
            "courseAvailable": "Доступно",
            "courseNotAvailable": "Недоступно",
            "courseLessons": "Уроки",
            "courseDuration": "Продолжительность",
            "courseDifficulty": "Сложность",
            "courseTagsTitle": "Навыки, которые вы приобретете",
            "courseLessonTitle": "Уроки",
            "courseContentTitle": "Подробнее",
            "courseSliderTitle": "Люди также покупают",
            "courseDiscount": "Калькулятор скидок",
            "courseDiscountText": "Напишите, сколько монет платформы вы готовы потратить, и мы рассчитаем для вас скидку",
            "courseDiscountMax": "Максимальная сумма, которую можно потратить:",
            "courseDiscountBalance": "Ваш баланс:",
            "courseDiscountDiscount": "Ваша скидка:",
            "courseDiscountUse": "Использовать скидку",
            "courseDiscountLater": "Позже",
            "courseDiscountLogin": "Войдите, чтобы использовать скидку",
            "courseDiscountQuantity": "Выберите количество:",
            "courseDiscountCoins": "Монеты",
            "courseDiscountCoin": " монет",
            "courseBuy": "Купить курс",
            "courseBuyDesc": "Ваш доступ к курсу оплачен на 3 месяца. Если вы не завершите курс за это время, вы можете продлить доступ, выбрав один из доступных вариантов продления.",
            "coursePlatformTitle": "Используйте монеты платформы при покупке курса",
            "coursePlatformDesc": "Вы можете использовать заработанные монеты для формирования скидки или полной оплаты курса",
            "lsTheory": "Теория",
            "lsPractice": "Практика",
            "lsTest": "Тест",
            "lsLearned": "Теория изучена",
            "lsTestDone": "Тест завершен",
            "lsTestPassed": "Тест пройден",
            "lsPracticeDone": "Практика пройдена",
            "lsPracticePassed": "Практика пройдена",
            "lsPracticeLocked": "Вы должны просмотреть видео до конца и нажать \"Теория пройдена\", чтобы получить доступ к практике и затем к следующим урокам...",
            "lsPracticeDoneHint": "Эта кнопка ативируется как только вы пройдете тест или все слайды. Нажмите её для получения доступа к следующему уроку.",
            "lsLessonsLocked": "Каждый урок доступен только после прохождения предыдущего",
            "lsTheoryError": "Вы должны полностью просмотреть видео",
            "lsModalTitle": "Отличная работа!",
            "lsModalDesc": "Продолжайте в том же духе и собирайте еще больше наград!",
            "lsModalContent": "Вы завершили урок и заработали:",
            "lrpPurchased": "Недавно купленные",
            "lrpStartBtn": "Начать курс",
            "lrpShareBtn": "Поделиться",
            "lrpProgress": "В процессе",
            "lrpStudies": "Последние обучения",
            "lrpCompleted": "Пройдено",
            "lrpLessons": "Уроки",
            "lrpCourseBtn": "К курсу",
            "lrpLessonsTitle": "Последние курсы",
            "lrpDescLessons": "Уроки:",
            "lrpValidPeriod": "Курс доступен до:",
            "lrpExtendPeriod": "Продлить",
            "lrpDescSpent": "Потрачено:",
            "lrpDescTime": "Время:",
            "lrpDescTimePoint": "ч",
            "lrpCoinsPoint": "до +",
            "lrpDescType": "Тип:",
            "lrpDescXp": "XP:",
            "lrpDescCoins": "Монеты:",
            "lrpDescBtn": "Продолжить",
            "lrpDescBtnFinal": "Пройдено",
            "lrpSertificate": "Посмотреть сертификат",
            "lrpSertModalTitle": "Сертификат прохождения",
            "lrpSertModalDesc": "Вы можете скачать сертификат о прохождении в любое время.",
            "lrpSertModalDownload": "Скачать",
            "lrpSertModalShare": "Поделиться",
            "lrpCpProgress": "Прогресс",
            "lrpCpLessons": "Ваши уроки",
            "extendTitle": "Продление курса",
            "extendDesc": "Вы можете продлить курс на определенный срок, если не успеваете его завершить.",
            "extendPeriod": "Выберите период",
            "extendAmount": "Сумма к оплате",
            "extendClose": "Позже",
            "extendContinue": "Перейти к оплате",
            "expiredTitle": "Доступ истек",
            "expiredText": "К сожалению, ваш доступ к этому курсу истек. Вы можете продлить его, выбрав желаемый срок и оплатив соответствующую сумму. Пожалуйста, выберите период продления, чтобы продолжить обучение!",
            "expiredButton": "Продлить",
            "tgTitle": "Хочу платить <span class=\"text-grayscale-900\">меньше</span>?",
            "tgDesc": "Зарабатывайте монеты в нашей игре GraphDEX в Telegram и обменивайте их на курс или получайте скидку. <br><br>Чтобы перевести заработанные монеты в DuoSchool, просто подключите свой аккаунт Telegram через раздел Настройки на нашей платформе.",
            "tgBtn": "Перейти в Telegram",
            "qquiz": "Тест",
            "qduration": "Длительность",
            "qquestions": "правильных ответов",
            "qcorrect": "Правильный ответ",
            "qcheck": "Проверить",
            "qcontinue": "Продолжить",
            "qgotit": "Понял",
            "qback": "Вернуться к теории",
            "qdone": "Тест завершен",
            "qserverError": "Ошибка сервера",
            "psmTitle": "Перейти на платформу",
            "psmDesc": "Пожалуйста, перейдите на платформу, чтобы применить полученные знания. Только после выполнения этого шага вы сможете перейти к следующему слайду.",
            "psmBtn": "Практика в действии",
            "psmClose": "Закрыть",
            "practice": "Практика",
            "test": "Тест",
            "min": "м",
            "ok": "ХОРОШО",
            "psmCompleateDesc": "Вы успешно завершили практику",
            "Difficulty": {
                "BEGINNER": "Начинающий",
                "MEDIUM": "Средний",
                "HARD": "Сложный",
                "EXPERT": "Эксперт"
            },
            "start": "СТАРТ",
            "finish": "ФИНИШ",
            "ProlongPeriod": {
                "ONE_MONTH": "1 месяц",
                "TWO_MONTH": "2 месяца",
                "TREE_MONTH": "3 месяца",
                "UNLIMITED": "Беcсрочно"
            },
            "lrpShareModalTitle": "Поделиться курсом",
            "lrpShareModalCopy": "Скопировать промокод",
            "lrpShareModalCopySuccess": "Скопировано",
            "lrpShareModalText01": "Вы можете скопировать ссылку и передать её кому-то, кому вы хотите подарить курс:",
            "lrpShareModalText02": "Скопируйте ссылку с промокодом",
            "lrpShareModalText03": "Передайте ссылку человеку, которому вы хотите подарить курс.",
            "lrpShareModalText04": "Получатель может использовать ссылку после входа на Платформу",
            "lrpShareModalText05": "Как только ссылка будет использована, мы пришлем вам уведомление.",
            "lrpShareModalLabel": "Промокод",
            "errorMsgAlreadyActivated": "Эта ссылка ошибочная или уже была активирована.",
            "errrorMsgTitle": "Ошибка"
        },
        "emails": {
            "verify_email_subject": "Подтвердите свой адрес электронной почты",
            "verify_email_line": "Пожалуйста, нажмите на кнопку ниже, чтобы подтвердить свой адрес электронной почты.",
            "verify_email_action": "Подтвердить адрес электронной почты",
            "verify_email_no_action": "Если вы не создавали аккаунт, дополнительных действий не требуется.",
            "all_rights": "Все права защищены.",
            "reset_password_subject": "Уведомление о сбросе пароля!!!",
            "reset_password_line": "Вы получили это письмо, потому что мы получили запрос на сброс пароля для вашей учетной записи.",
            "reset_password_action": "Сбросить пароль",
            "reset_password_expiry": "Ссылка на сброс пароля истечет через {count} минут.",
            "reset_password_no_action": "Если вы не запрашивали сброс пароля, больше никаких действий не требуется.",
            "greeting": {
                "default": "Здравствуйте!",
                "error": "Упс!"
            },
            "regards": "С уважением",
            "subcopy": "Если у вас возникли проблемы с нажатием кнопки \"{actionText}\", скопируйте и вставьте URL ниже\nв адресную строку браузера:",
            "expired": "Доступ к курсу!",
            "prolongation": "Продление доступа к курсу!"
        },
        "global": {
            "Today": "Сегодня",
            "Yesterday": "Вчера",
            "PromoCodeHasBeenActivated": "Промокод активирован",
            "ThePromoCodeWasApplied": "Промокод {promo_code} был применен.",
            "ContinueLearning": "Продолжить обучение",
            "langTitle": "Выберите ваш язык",
            "langError": "Выберите удобный язык обучения",
            "langWarning": "",
            "home": "Главная",
            "learning": "Обучение",
            "ranks": "Топ",
            "shop": "Магазин",
            "courses": "Курсы",
            "referral": "Реферал",
            "settings": "Настройки",
            "help": "Помощь",
            "logout": "Выйти",
            "profile": "Профиль",
            "btDashboard": "Панель управления",
            "btHelp": "Помощь",
            "btTokens": "API токены",
            "btCheckoutError": "Ошибка при оформлении",
            "btCheckoutSuccess": "Оформление успешно",
            "btCourses": "Курсы",
            "btCourse": "Курс",
            "btLeaderboard": "Таблица лидеров",
            "btLearningCourse": "Курс обучения",
            "btLearning": "Обучение",
            "btLesson": "Урок",
            "btShop": "Магазин",
            "btCertificate": "Сертификат",
            "btReferrals": "Мои рефералы",
            "btProfile": "Профиль",
            "btPrivacy": "Политика конфиденциальности",
            "btTerms": "Условия и положения",
            "btCookies": "Политика использования cookies",
            "ncTitle": "У вас нет приобретенных курсов",
            "ncText": "К сожалению, у вас пока нет приобретенных курсов, поэтому здесь нет доступного контента. Приобретите курс, и вы сможете получить доступ к соответствующей информации на этой странице.",
            "ncButton": "Посмотреть курсы",
            "ibTitle": "Начать гонку",
            "ibText": "Заработать монеты",
            "ibLink": "Гонка",
            "tabMenuJourney": "Путешествие",
            "tabMenuCourses": "Топ курсы",
            "tabMenuNews": "Новости",
            "title": "Ваше путешествие в",
            "level": "Уровень",
            "coursesTitle": "Топ курсы",
            "newsTitle": "Узнайте больше о нас",
            "pShareArticle": "Поделиться",
            "pSimilarArticle": "Похожие статьи",
            "refTitle": "Мои рефералы",
            "refTitleTransactions": "Транзакции рефералов",
            "refTableName": "Рефералы",
            "refTableBonus": "Бонус",
            "refTableDate": "Дата",
            "refInviteTitle": "Пригласить друга",
            "refInviteText": "Получите <strong class=\"text-white font-bold\">10%</strong> от покупок друзей ",
            "refInviteLink": "Копировать свою реферальную ссылку",
            "refInviteCopySuccess": "Скопировано",
            "refInviteCopyError": "Ошибка копирования",
            "refInviteOr": "или",
            "refInviteButton": "Показать QR",
            "refInviteBalance": "Баланс за покупки рефералов",
            "refInviteBalanceBtn": "Вывести",
            "refModalTitle": "QR код",
            "refModalDownload": "Скачать QR",
            "refModalClose": "Закрыть",
            "pagItems": "Элементы {from} - {to} из {total}",
            "pagShow": "Показать:",
            "topMenuDaily": "Дневной",
            "topMenuWeekly": "Недельный",
            "topMenuMonthly": "Месячный",
            "topStatHave": "У вас",
            "topStatHaveBtn": "Продолжить обучение",
            "topStatRank": "Ваш рейтинг",
            "topStatRankBtn": "Посмотреть в лидерборде",
            "topTableSearch": "Искать по имени",
            "topTableRank": "Рейтинг",
            "topTableName": "Имя",
            "topTableCompleted": "Пройденные уроки",
            "topTableWin": "Бонус за вход",
            "topTableTotal": "Всего XP",
            "pfCoin": "монет",
            "pfCoinLink": "Перейти к курсам",
            "pfXpLink": "Таблица лидеров",
            "pfOverview": "Обзор",
            "pfOverAttendance": "Посещаемость",
            "pfOverAttendanceDays": "дней",
            "pfOverCourses": "Курсы",
            "pfOverCoursesDone": "завершено",
            "pfAttendanceTitle": "Посещаемость",
            "pfAttendanceDesc": "Получайте ежедневные награды. Если вы пропустите день, ваш прогресс будет сброшен.",
            "pfAttendanceDay": "День",
            "carModalTitle": "Вы просто молодец!",
            "carModalDesc": "Продолжайте в том же духе!",
            "carModalPrize": "Вот ваш приз:",
            "fAbout": "О нас",
            "fPrivacy": "Политика конфиденциальности",
            "fAgreement": "Условия и положения",
            "fCookie": "Политика использования файлов cookie",
            "fCopy": "Все права защищены DuoSchool.ai",
            "bePromoNotFound": "Промокод не найден",
            "bePromoMissing": "Отсутствует номинал промокода.",
            "bePromoExpired": "Промокод не действителен",
            "bePromoCourse": "Данный промокод может быть применен только к курсу",
            "bePromoCourseDenied": "Промокод не может быть применен к текущему курсу",
            "bePromoCourseProlong": "Промокод не может быть применен к продлению курса",
            "beOrderItem": "Товар не найден",
            "beOrderUser": "Пользователь не найден",
            "beCoinsOrder": "Недостаточно монет для этого заказа.",
            "beCheckoutEmpty": "Корзина пуста",
            "beCheckoutOrder": "Заказ не найден",
            "beCheckoutMissing": "Отсутствует причина неудачной попытки оплаты.",
            "beCourseNotFound": "Курс не найден",
            "beCourseStarted": "Курс уже начат.",
            "beCourseNotStarted": "Мы не можем начать курс без уроков.",
            "beCourseCoursePlan": "Невозможно купить план курса сейчас",
            "beCartAdd": "Невозможно добавить продукт в корзину",
            "beCartPayment": "Невозможно получить способы оплаты",
            "beCartEmpty": "Ваша корзина пуста.",
            "beCartMissingPM": "Отсутствует способ оплаты",
            "beCartCreateSession": "Не удается создать сессию оформления заказа",
            "beCartPromoMissed": "Отсутствует промокод",
            "beCartPromoUsed": "Промокод уже использован",
            "beLearningCourse": "Отсутствует курс пользователя.",
            "beLearningStart": "Мы не можем начать этот курс сейчас, пожалуйста, свяжитесь со службой поддержки.",
            "beLessonView": "Вы не можете просматривать этот урок.",
            "beLessonSlideId": "Отсутствует идентификатор слайда",
            "beLessonSlideProcess": "Не удается обработать слайд галереи.",
            "beLessonAnswerCheck": "Не удается проверить ответ на вопрос.",
            "beLessonTheoryFail": "Не удалось завершить теорию, попробуйте еще раз или свяжитесь с поддержкой.",
            "beLessonPracticeFail": "Не удалось завершить практику, попробуйте еще раз или свяжитесь с поддержкой.",
            "dailyModalTitle": "Обновление заработка",
            "dailyModalDesc": "Вы заработали за вход в систему на ваш {day}-й подряд день! Продолжайте в том же духе, чтобы получить еще больше наград!",
            "dailyModalPrize": "Вот ваш приз:",
            "portugal": "Португалия",
            "leaderBoardPeriod": "Cтатистика обновляется каждый час.",
            "certTitle": "Сертификат о прохождении",
            "certDesc": "Этот сертификат подтверждает, что студент успешно прошел курс",
            "certDesc2": "",
            "headerNotify": "Добавьте ваше имя к вашему профайлу для получения сертификатов.",
            "headerNotifyLink": "Изменить профиль.",
            "helpBannerTitle": "Не нашли ответ?",
            "helpBannerDesc": "Напишите нам свой вопрос на любой удобной платформе. Мы ответим вам как можно скорее.",
            "HelpTopics": {
                "ALL": "Все",
                "SETTINGS": "Профиль",
                "PLATFORM": "Курсы",
                "AI": "О проекте",
                "FAQ": "Часто задаваемые вопросы"
            }
        },
        "lp": {
            "navCourse": "Курсы",
            "navAbout": "О нас",
            "navNews": "Блог",
            "login": "Войти",
            "register": "Начать сейчас",
            "subscribe": "Подпишитесь на нашу рассылку",
            "emailPalceholder": "Электронная почта",
            "navigation": "Навигация",
            "policies": "Правила",
            "courses": "Курсы",
            "about": "О нас",
            "news": "Новости",
            "cookie": "Политика использования файлов cookie",
            "privacy": "Политика конфиденциальности",
            "agreement": "Правила и условия",
            "contacts": "Связаться с нами",
            "copy": "© 2025 — DuoSchool",
            "courseTitle": "Лучшие курсы",
            "courseBuy": "Купить сейчас",
            "bTitle": "Изучайте новые <span class=\"text-primary-500\">навыки</span> вместе с любимыми блогерами и экспертами",
            "bText": "Мы собрали лучшие образовательные программы по ИИ и криптовалютам в одном месте специально под ваши потребности. Получайте сертификаты, делитесь опытом, зарабатывайте бонусы и участвуйте в нашей реферальной программе.",
            "bButton": "Как это работает?",
            "lpNotes": "Курсы по ИИ и криптовалютам",
            "lpWidget": "Встроенные виджеты для практики",
            "lpCursor": "Интерактивное обучение",
            "lpSale": "Бонусные баллы за достижения",
            "lpCup": "Мотивационный рейтинг",
            "lpGamepad": "Случайная бонусная игра",
            "mTitle": "Освойте самые востребованные навыки в ИИ и криптовалютах",
            "mTitle1": "Криптовалюта",
            "mText1": "Блокчейн и криптовалюта изменили наше представление о финансах. С ростом крипторынка понимание его особенностей становится крайне важным. Начните с наших курсов по основам крипты, а затем переходите к более сложным программам по трейдингу на CEX, DEX, мем-коинам и ретродропам.",
            "mBtn1": "Выбрать курс",
            "mTitle2": "Искусственный интеллект",
            "mText2": "Понимание ИИ больше не является опцией — это необходимость в мире, где технологии движут всем. С нашими курсами вы начнёте с основ, а затем перейдёте к специализированным темам по ИИ-видео, изображениям и текстам. Обучение проводят виртуальные эксперты, созданные на основе ИИ.",
            "mBtn2": "Выбрать курс",
            "sTitle": "Любимец студентов",
            "sBlockTitle": "Стартовый",
            "sBlockText": "Наш курс погрузит вас в мир криптовалют и блокчейна с нуля, помогая освоить не только теорию, но и получить практический опыт. Мы начинаем с основ: вы узнаете, что такое криптовалюты, как они работают, их роль в современной экономике и почему за ними будущее финансов.",
            "sBlockPrimaryBtn": "Начать сейчас",
            "sBlockSecondaryBtn": "Узнать больше",
            "jTitle": "Ваш путь обучения",
            "jTabTitle1": "Теоретическая часть",
            "jTabContent1": "Учитесь с помощью понятных видеоуроков, которые создают прочную базу знаний.",
            "jTabTitle2": "Практическая часть",
            "jTabContent2": "Применяйте знания на практике через реальные задания и кейсы.",
            "jTabTitle3": "Заработок бонусов",
            "jTabContent3": "Получайте награды по мере прохождения курса — за выполнение заданий и достижение целей.",
            "jTabTitle4": "Траты монет",
            "jTabContent4": "Обменивайте заработанные монеты на эксклюзивные награды.",
            "tTitle": "",
            "tText": "Хотите учиться на выгодных условиях? Посетите бота наших партнёров и получите курс. Не упустите эксклюзивное предложение.",
            "tBtn": "Перейти в Telegram",
            "lTitle1": "Экономьте с нашими пакетами курсов",
            "lText1": "Погрузитесь в мир криптовалют и ИИ по выгодной цене",
            "lTitle2": "Зарабатывайте с нашей реферальной программой",
            "lText2": "Приглашайте друзей учиться на нашей платформе и получайте кэшбэк!",
            "lTitle3": "Открывайте скидки за монеты!",
            "lText3": "Используйте монеты платформы, чтобы экономить на курсах.",
            "lMore": "Узнать больше",
            "cTitle": "Почему стоит выбрать именно наши курсы?",
            "cText": "Мы объединяем теорию, практику и увлекательную систему наград, чтобы вы приобрели полезные навыки для вызовов в сфере ИИ и криптовалют.",
            "cBtn": "Выбрать курс",
            "cTitle1": "Много языков",
            "cText1": "Выберите любой язык и учитесь без необходимости постоянного перевода.",
            "cTitle2": "Эксперты ИИ",
            "cText2": "Наши виртуальные эксперты на базе ИИ покажут вам, как стать профи в крипте и ИИ.",
            "cTitle3": "Реферальная программа",
            "cText3": "Получайте бонусы за приглашение друзей на платформу и обменивайте их на классные награды.",
            "cTitle4": "Практическая часть",
            "cText4": "Теория важна, но мы покажем, как применять знания на практике.",
            "cTitle5": "Полноценные курсы",
            "cText5": "Мы предлагаем лучшие курсы по ИИ и криптовалютам, объединяя наш опыт с передовыми образовательными методиками.",
            "aTitle": "Часто задаваемые вопросы",
            "oTitle": "Остались вопросы?",
            "oText": "Если у вас остались вопросы — напишите нам. Мы здесь, чтобы помочь вам достичь успеха.",
            "oBtn": "Связаться с нами",
            "aQuestion1": "Подходят ли курсы для новичков, или нужно предварительное знание?",
            "aAnswer1": "Наши курсы рассчитаны на новичков. Вы можете начать с основ и постепенно перейти к более сложным темам.",
            "aQuestion2": "Как зарабатывать и использовать бонусы и монеты на платформе?",
            "aAnswer2": "Вы получаете бонусы за выполнение заданий и достижение целей. Их можно обменять на скидки, призы, улучшения в игре и другое.",
            "aQuestion3": "Какой сертификат я получу после прохождения курса?",
            "aAnswer3": "Вы получите цифровой сертификат о завершении курса.",
            "aQuestion4": "Как участвовать в реферальной программе и какие преимущества?",
            "aAnswer4": "Наша реферальная программа позволяет получать 10% от суммы, потраченной вашими друзьями на курсы. Приглашайте друзей и используйте бонусы как пожелаете!",
            "aQuestion5": "Смогу ли я получить доступ к материалам после завершения курса?",
            "aAnswer5": "Да, материалы доступны в течение определенного времени после завершения курса. Чтобы продлить доступ, потребуется дополнительная оплата.",
            "newsTitle": "Читайте новое в нашем блоге",
            "newsMore": "Читать дальше",
            "newPreheader": "Мы придерживаемся международного права и этических норм, не сотрудничая со странами, ведущими агрессивную политику.",
            "newBannerExtraTitle": "DuoSchool",
            "newBannerTitle": "ваш проводник в обучение нового поколения",
            "newBannerCheck01": "Обучение от ИИ",
            "newBannerCheck02": "Любимо всеми",
            "newBannerBtnStart": "Начать бесплатно",
            "newBannerBtnLearn": "Узнать больше",
            "partnersTitle": "Эти компании",
            "partnersExtraTitle": "сотрудничают с нами",
            "partnersText1": "— лидер в мире криптовалют с более чем <span class=\"text-accent\">250 миллионами пользователей в 180+ странах</span>",
            "partnersText2": "— одна из ведущих бирж цифровых активов, которой доверяют более <span class=\"text-accent\">30 миллионов пользователей в 170+ странах</span>",
            "partnersText3": "— инновационная компания, специализирующаяся на MEV, с более чем <span class=\"text-accent\">150 успешными токенами</span> и интеграциями на 100+ DEX и CEX.",
            "partnersText4": "— платформа для построения графиков с аналитическими инструментами и социальной сетью из более чем <span class=\"text-accent\">50 миллионов трейдеров</span> и инвесторов.",
            "partnersText5": "— ведущая аналитическая платформа, которая <span class=\"text-accent\">предоставляет данные в реальном времени</span> и аналитические обзоры по <span class=\"text-accent\">DeFi-сектору</span>.",
            "partnersText6": "— вторая по объему торгов криптовалютная биржа с огромным сообществом из более чем <span class=\"text-accent\">60 миллионов пользователей</span> по всему миру",
            "countdownTitle": "Откройте выгодные предложения на курсы по крипте",
            "countdownText": "Подпишитесь на нашего Telegram-бота и получите эксклюзивную скидку на криптокурсы!",
            "countdownBtn": "Получить скидку",
            "countdownDay": "д",
            "countdownHour": "ч",
            "countdownMin": "м",
            "countdownSec": "с",
            "perfectCoursesTitle": "Наши курсы идеально подходят для:",
            "perfectCoursesItemTitle1": "Новичков, которые хотят погрузиться в крипту и ИИ",
            "perfectCoursesItemText1": "Думаете, это слишком сложно? Только не с нами! Мы поможем вам освоить основы, покажем, как получить первую прибыль и убережём от типичных ошибок.",
            "perfectCoursesItemTitle2": "Тех, кто хочет прокачать навыки",
            "perfectCoursesItemText2": "Освойте продвинутые стратегии трейдинга и ИИ, которые помогут стабильно зарабатывать до $2000 и чувствовать себя уверенно на стремительно развивающихся рынках.",
            "perfectCoursesItemTitle3": "Тех, кто хочет опережать тренды",
            "perfectCoursesItemText3": "Освойте востребованные навыки в блокчейне и ИИ, которые откроют перед вами новые возможности. Зарабатывайте до $3000 и раскрывайте свой потенциал без ограничений!",
            "perfectCoursesItemBtn": "Посмотреть курс",
            "certificationTitle": "Получите сертификат!",
            "certificationText": "Завершите курс и подтвердите свой опыт",
            "certificationBtn": "Найти курс",
            "leaderboardTitle": "Поднимайтесь в рейтинге и получайте эксклюзивные бонусы!",
            "leaderboardText": "Каждую неделю и месяц 3 лучших студента получают особые награды. Например:",
            "leaderboardBtn": "Подробнее",
            "leaderboardBlockTitle1": "Зарабатывайте с нашей реферальной программой",
            "leaderboardBlockText1": "Приглашайте друзей учиться на платформе и получайте кэшбэк!",
            "leaderboardBlockTitle2": "Открывайте скидки за монеты!",
            "leaderboardBlockText2": "Используйте монеты платформы, чтобы сэкономить на курсах.",
            "pTestimonialTitle": "Экспертная поддержка и вебинары от:",
            "pTestimonialText1": "Алекс, основатель и CEO Peanut Trade, имеет более десяти лет опыта в IT и с 2013 года активно работает в блокчейн-сфере.",
            "pTestimonialText2": "Он участвовал в ICO Ethereum, а в 2014 году запустил BitX — стартап, который позволял оплачивать телеком и другие услуги биткойнами. Также он майнил биткойн с 2015 года и принимал участие в создании украинских майнеров Hotmine на чипах Bitfury.",
            "pTestimonialText3": "Алекс успешно привлёк более $30 миллионов для трёх проектов: Remme, Hackless и Peanut Trade. С 2015 года он занимается майнингом и входит в правление Bitcoin Foundation Ukraine.",
            "pTestimonialText4": "Кроме того, он является членом рабочей группы по подготовке законодательства о криптовалютах в Украине.",
            "pTestimonialName": "Алекс Момот",
            "pTestimonialJob": "Основатель и CEO Peanut Trade",
            "opTitle": "Откройте для себя удивительные возможности обучения!",
            "opBtn": "Начните сейчас бесплатно",
            "opContentTitleB1": "Гибкость",
            "opContentB1Text1": "Структурированные курсы – Теория и практика",
            "opContentB1Text2": "Возможность учиться в своем темпе – В любое время, в любом месте",
            "opContentB1Text3": "Выберите предпочтительный язык",
            "opContentB1Text4": "Опыт не требуется, подходит для начинающих",
            "opContentB1Text5": "Доступ к каналу в Discord",
            "opContentTitleB2": "Поддержка",
            "opContentB2Text1": "Сеансы устранения сомнений 24/7 с ИИ-агентами",
            "opContentB2Text2": "Поддержка наставников",
            "opContentB2Text3": "Регулярные вебинары и AMA-сессии с экспертами",
            "opContentTitleB3": "Сообщество",
            "opContentB3Text1": "Дружелюбное международное сообщество",
            "opContentB3Text2": "Таблица лидеров и игры на платформе",
            "opContentB3Text3": "Уникальные NFT для лучших студентов",
            "opContentTitleB4": "Расширенные возможности",
            "opContentB4Text1": "Продвинутые стратегии и аналитика в трейдинге",
            "opContentB4Text2": "Бонусы и скидки на новые курсы",
            "opContentB4Text3": "Выбор языка обучения",
            "opContentB4Text4": "Сертификат по завершении курса",
            "opContentB4Text5": "Отличная реферальная программа",
            "studentsTitle": "студентов уже учатся с нами",
            "studentsBtn": "Начните сейчас бесплатно",
            "catTitle": "Выберите курс, который лучше всего соответствует вашим потребностям",
            "catCouseTitle00": "Криптовалюта для начинающих",
            "catCouseTitle01": "Торговля мемкоинами: от теории к практике",
            "catCouseTitle02": "Трейдинг: от теории к практике",
            "catCouseTitle03": "Искусственный интеллект для начинающих",
            "catCouseTitle04": "Продвинутый ИИ: от теории к мастерству",
            "catCouseTopicCrypto": "Крипто Крус",
            "catCouseTopicTrading": "Трейдинг Курс",
            "catCouseTopicAi": "ИИ Курс",
            "catCouseBtn": "Выбрать вариант",
            "catCryptoTitle": "Криптовалютные курсы",
            "catAiTitle": "Курсы по искусственному интеллекту",
            "lModalTitle": "Уроки",
            "tradingHeroTitle": "Трейдинг: от теории к практике",
            "tradingHeroText1": "Трейдинг может показаться сложным, но поверьте — это совсем не обязательно так.",
            "tradingHeroText2": "На этом курсе мы начнём с основ и будем пошагово развивать ваши навыки. Вас ждёт сбалансированное сочетание теории и практики, чтобы вы не просто изучали, а готовились к реальным действиям! К концу курса вы будете чувствовать себя гораздо увереннее на финансовых рынках — как в классических активах, так и в захватывающем мире криптовалют.",
            "tradingHeroText3": "Этот курс идеально подойдёт как полным новичкам, так и тем, кто уже пробовал трейдинг, но не знает, как двигаться дальше. А также для тех, кто задумывается о трейдинге как о полноценной профессии.",
            "tradingOptions": "Выберите вариант",
            "tradingOptionsReviews": "отзывов",
            "tradingOptionsDuration": "Длительность:",
            "tradingOptionsHour": "ч",
            "tradingOptionsMinute": "мин",
            "tradingOptionsExperts": "Эксперты:",
            "tradingOptionsExpertsName": "ИИ Алекс и Эмма",
            "tradingOptionsEarn": "Доход:",
            "tradingOptionsEarnTo": "До",
            "tradingOptionsIncluded": "Что входит в курс",
            "tradingOptionsListBtn": "Посмотреть уроки",
            "tradingOptionsBuy": "Купить сейчас",
            "tradingOptionsTitle1": "Базовый",
            "tradingOptionsTitle2": "Средний",
            "tradingOptionsTitle3": "Профи",
            "tradingOptionsList01Item01": "Доступ к курсу на 1 месяц",
            "tradingOptionsList01Item02": "27 уроков",
            "tradingOptionsList01Item03": "Участие в рейтинге",
            "tradingOptionsList01Item04": "Базовая поддержка",
            "tradingOptionsList01Item05": "Бесплатные PDF-материалы",
            "tradingOptionsList02Item01": "Доступ к курсу на 1 месяц",
            "tradingOptionsList02Item02": "Все 54 урока",
            "tradingOptionsList02Item03": "Участие в рейтинге",
            "tradingOptionsList02Item04": "Базовая поддержка",
            "tradingOptionsList02Item05": "Бесплатные PDF-материалы",
            "tradingOptionsList02Item06": "Сертификат",
            "tradingOptionsList02Item07": "Бесплатные вебинары",
            "tradingOptionsList02Item08": "Доступ в приватное сообщество на 1 месяц",
            "tradingOptionsList02Item09": "AMA-сессии",
            "tradingOptionsList03Item01": "Доступ к курсу на 3 месяца",
            "tradingOptionsList03Item02": "Все 54 урока",
            "tradingOptionsList03Item03": "Участие в рейтинге",
            "tradingOptionsList03Item04": "Круглосуточная поддержка ИИ",
            "tradingOptionsList03Item05": "Набор PDF-материалов",
            "tradingOptionsList03Item06": "Сертификат",
            "tradingOptionsList03Item07": "Дополнительные видео каждые 2 недели",
            "tradingOptionsList03Item08": "Доступ в приватное сообщество на 3 месяца",
            "tradingOptionsList03Item09": "Ежемесячные AMA-сессии с лидерами криптоиндустрии",
            "tradingOptionsList03Item10": "Еженедельные AMA-сессии с кураторами",
            "tradingOptionsList03Item11": "Уникальный NFT",
            "tradingOptionsList03Item12": "Возможность трудоустройства в ведущие криптокомпании мира",
            "tradingOptionsList03Item13": "Доступ к бета-версиям новых инструментов и сервисов",
            "tradingSureTitle": "Не уверены, что этот курс вам подходит?",
            "tradingSureText": "Ознакомьтесь со списком уроков, а чтобы убедиться наверняка — пройдите пару уроков БЕСПЛАТНО! Оцените сами, насколько ценный и удобный у нас курс.",
            "tradingSureBtn": "Начать бесплатно",
            "tradingReviewTitle": "Вдохновляйтесь",
            "tradingReviewText": "Узнайте, как другие студенты изменили свою карьеру и жизнь с помощью DuoSchool",
            "tradingAlsoBuyTitle": "Также покупают",
            "memeHeroTitle": "Трейдинг мем-коинов: от теории к практике",
            "memeHeroText1": "Интересуетесь ажиотажем вокруг мем-коинов? Этот курс поможет вам разобраться в этой захватывающей нише крипторынка!",
            "memeHeroText2": "Вы узнаете, как эффективно анализировать мем-коины, находить потенциальных победителей и ориентироваться в нестабильной рыночной среде.",
            "memeHeroText3": "Будь вы новичок, полный интереса, или трейдер, желающий усилить свой портфель — этот курс даст ценные знания, которые могут приумножить ваши инвестиции.",
            "memeOptionsList01Item01": "Доступ к курсу на 1 месяц",
            "memeOptionsList01Item02": "27 уроков",
            "memeOptionsList01Item03": "Участие в рейтинге",
            "memeOptionsList01Item04": "Базовая поддержка",
            "memeOptionsList01Item05": "Бесплатные PDF-материалы",
            "memeOptionsList02Item01": "Доступ к курсу на 1 месяц",
            "memeOptionsList02Item02": "Все 38 уроков",
            "memeOptionsList02Item03": "Участие в рейтинге",
            "memeOptionsList02Item04": "Базовая поддержка",
            "memeOptionsList02Item05": "Бесплатные PDF-материалы",
            "memeOptionsList02Item06": "Сертификат",
            "memeOptionsList02Item07": "Бесплатные вебинары",
            "memeOptionsList02Item08": "Доступ в приватное сообщество на 1 месяц",
            "memeOptionsList02Item09": "AMA-сессии",
            "memeOptionsList03Item01": "Доступ к курсу на 3 месяца",
            "memeOptionsList03Item02": "Все 38 уроков",
            "memeOptionsList03Item03": "Участие в рейтинге",
            "memeOptionsList03Item04": "Круглосуточная поддержка ИИ",
            "memeOptionsList03Item05": "Набор PDF-материалов",
            "memeOptionsList03Item06": "Дополнительные видеоматериалы каждую неделю",
            "memeOptionsList03Item07": "Сертификат",
            "memeOptionsList03Item08": "Доступ в приватное сообщество на 3 месяца",
            "memeOptionsList03Item09": "Ежемесячные AMA-сессии с лидерами криптоиндустрии",
            "memeOptionsList03Item10": "Еженедельные AMA-сессии с кураторами",
            "memeOptionsList03Item11": "Уникальный NFT",
            "memeOptionsList03Item12": "Возможность трудоустройства в ведущие криптокомпании мира",
            "starterHeroTitle": "Криптовалюта для начинающих",
            "starterHeroText1": "Если вы слышали о криптовалютах и блокчейне, но не знаете, с чего начать — этот курс создан для вас! Мы объясним всё — от основ до практических знаний, чтобы вы могли полноценно понять, как работают криптовалюты и почему они формируют будущее финансов.",
            "starterHeroText2": "К окончанию курса вы будете чётко понимать, что такое крипта, какова её роль в мировой экономике и почему это не просто модный тренд.",
            "starterHeroText3": "Этот курс отлично подойдёт всем, кто хочет наконец-то разобраться в мире крипты и открыть для себя увлекательные возможности заработка с помощью цифровых валют.",
            "starterOptionsList01Item01": "Доступ к курсу на 1 месяц",
            "starterOptionsList01Item02": "19 уроков",
            "starterOptionsList01Item03": "Участие в рейтинге",
            "starterOptionsList01Item04": "Базовая поддержка",
            "starterOptionsList02Item01": "Доступ к курсу на 3 месяца",
            "starterOptionsList02Item02": "19 уроков",
            "starterOptionsList02Item03": "Участие в рейтинге",
            "starterOptionsList02Item04": "Личная поддержка 24/7",
            "starterOptionsList02Item05": "Сертификат",
            "starterOptionsList02Item06": "Набор PDF-материалов",
            "starterOptionsList02Item07": "Дополнительные видеоматериалы каждые 2 недели",
            "starterOptionsList02Item08": "Возможность заработать",
            "beginerCourseDifficulty": "Средний",
            "beginerCourseTitle": "Стартовый",
            "beginerCourseType": "Трейдинг Курс",
            "beginerCourseBtn": "Выбрать вариант",
            "tradeCourseDifficulty": "Сложный",
            "tradeCourseTitle": "Трейдинг",
            "tradeCourseType": "Трейдинг Курс",
            "tradeCourseBtn": "Выбрать вариант",
            "memeCourseDifficulty": "Сложный",
            "memeCourseTitle": "Мемкоины",
            "memeCourseType": "Крипто Курс",
            "memeCourseBtn": "Выбрать вариант"
        },
        "passwords": {
            "password": "Пароль должен быть длиной не менее шести символов и совпадать с подтверждением.",
            "reset": "Ваш пароль установлен!",
            "sent": "Ссылка для восстановления пароля отправлена!",
            "token": "Неверный код сброса пароля.",
            "user": "Не удалось найти пользователя с указанным электронным адресом."
        },
        "validation": {
            "accepted": "Вы должны принять {attribute}.",
            "active_url": "Поле {attribute} is not a valid URL.",
            "after": "Поле {attribute} должно быть датой после {date}.",
            "after_or_equal": "Поле {attribute} должно быть датой после или равной {date}.",
            "alpha": "Поле {attribute} может содержать только буквы.",
            "alpha_dash": "Поле {attribute} может содержать только буквы, цифры, дефис и подчеркивание.",
            "alpha_num": "Поле {attribute} может содержать только буквы и цифры.",
            "array": "Поле {attribute} должно быть массивом.",
            "before": "Поле {attribute} должно быть датой перед {date}.",
            "before_or_equal": "Поле {attribute} должно быть датой перед или равной {date}.",
            "between": {
                "numeric": "Поле {attribute} должно быть между {min} и {max}.",
                "file": "Размер {attribute} должен быть от {min} до {max} килобайт.",
                "string": "Длина {attribute} должна быть от {min} до {max} символов.",
                "array": "Поле {attribute} должно содержать {min} - {max} элементов."
            },
            "boolean": "Поле {attribute} должно быть логической истинной или ложью.",
            "confirmed": "Поле {attribute} не совпадает с подтверждением.",
            "date": "Поле {attribute} не является датой.",
            "date_format": "Поле {attribute} не соответствует формату {format}.",
            "different": "Поля {attribute} и {other} должны различаться.",
            "digits": "Длина цифрового поля {attribute} должна быть {digits}.",
            "digits_between": "Длина цифрового поля {attribute} должна быть между {min} и {max}.",
            "dimensions": "Поле {attribute} имеет недопустимые размеры изображения.",
            "distinct": "Поле {attribute} имеет повторяющееся зачение.",
            "email": "Поле {attribute} должно быть действительным электронным адресом.",
            "exists": "Выбранное значение для {attribute} некорректно.",
            "file": "Поле {attribute} должно быть файлом.",
            "filled": "Поле {attribute} обязательно для заполнения.",
            "image": "Поле {attribute} должно быть изображением.",
            "in": "Выбранное значение для {attribute} ошибочно.",
            "in_array": "Поле {attribute} не существует в {other}.",
            "integer": "Поле {attribute} должно быть целым числом.",
            "ip": "Поле {attribute} должно быть действительным IP-адресом.",
            "ipv4": "Поле {attribute} должно быть действительным IPv4-адресом.",
            "ipv6": "Поле {attribute} должно быть действительным IPv6-адресом.",
            "json": "Поле {attribute} должно быть валидной JSON строкой.",
            "max": {
                "numeric": "Поле {attribute} должно быть не больше {max}.",
                "file": "Поле {attribute} должно быть не больше {max} Килобайт.",
                "string": "Поле {attribute} должно быть не длиннее {max} символов.",
                "array": "Поле {attribute} должно содержать не более {max} элементов."
            },
            "mimes": "Поле {attribute} должно быть файлом одного из типов: {values}.",
            "mimetypes": "Поле {attribute} должно быть файлом одного из типов: {values}.",
            "min": {
                "numeric": "Поле {attribute} должно быть не менее {min}.",
                "file": "Поле {attribute} должно быть не менее {min} Килобайт.",
                "string": "Поле {attribute} должно быть не короче {min} символов.",
                "array": "Поле {attribute} должно содержать не менее {min} элементов."
            },
            "not_in": "Выбранное значение для {attribute} ошибочно.",
            "numeric": "Поле {attribute} должно быть числом.",
            "present": "Поле {attribute} должно присутствовать.",
            "regex": "Поле {attribute} имеет ошибочный формат.",
            "required": "Поле {attribute} обязательно для заполнения.",
            "required_if": "Поле {attribute} обязательно для заполнения, когда {other} равно {value}.",
            "required_unless": "Поле {attribute} обязательно для заполнения, когда {other} не равно {values}.",
            "required_with": "Поле {attribute} обязательно для заполнения, когда {values} указано.",
            "required_with_all": "Поле {attribute} обязательно для заполнения, когда {values} указаны.",
            "required_without": "Поле {attribute} обязательно для заполнения, когда {values} не указано.",
            "required_without_all": "Поле {attribute} обязательно для заполнения, когда {values} не указаны.",
            "same": "Значение {attribute} должно совпадать с {other}.",
            "size": {
                "numeric": "Поле {attribute} должно быть {size}.",
                "file": "Поле {attribute} должно быть {size} Килобайт.",
                "string": "Поле {attribute} должно быть длиной {size} символов.",
                "array": "Количество элементов в поле {attribute} должно быть {size}."
            },
            "string": "Поде {attribute} должно быть строкой.",
            "timezone": "Поле {attribute} должнобыть валидной временной зоной.",
            "unique": "Такое значение поля {attribute} уже существует.",
            "uploaded": "Загрузка поля {attribute} не удалась.",
            "url": "Поле {attribute} имеет ошибочный формат.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "email": {
                    "unique": "Этот адрес электронной почты уже зарегистрирован."
                }
            },
            "attributes": {
                "email": "электронная почта",
                "username": "имя пользователя"
            }
        }
    },
    "uk": {
        "about": {
            "greetingTitle": "Привіт!",
            "continueTitle": "Ми — ваш квиток у світ криптовалют і штучного інтелекту",
            "descriptionTitle": "Опановуйте нові навички за допомогою наших курсів, створених експертами!",
            "startLearningBtn": "Почати навчання",
            "becomePartnerBtn": "Стати партнером",
            "whatDuoSchool": "Що таке",
            "whatDuoSchoolName": "DuoSchool?",
            "duoSchoolDescriptionTitle1": "Ми — онлайн-школа, яка пропонує курси з криптовалют і штучного інтелекту.",
            "duoSchoolDescription1": "Наші освітні програми адаптовані під потреби студентів і варіюються від початкового до просунутого рівня — наприклад, ви можете почати свій шлях з основ і перейти до складних торговельних стратегій.",
            "duoSchoolDescription2": "Щоб допомогти студентам навчатися ефективніше, ми використовуємо інтерактивний підхід, що включає теорію, практику, бонуси та реферальну програму. Зароблені бонуси можна обмінювати на ексклюзивні винагороди. Наприкінці кожного курсу студенти, які успішно виконали всі завдання, отримують сертифікати.",
            "duoSchoolDescriptionTitle2": "Наша мета",
            "duoSchoolDescription3": "Криптовалюти та ШІ повільно, але впевнено захоплюють світ. Ми хочемо навчити людей користуватися ними та допомогти їм стати фінансово грамотнішими.",
            "panelTitle": "Готові вивчити щось новеньке?",
            "panelDescription": "Оберіть відповідний курс і почніть свій шлях до успіху!",
            "whyTitle": "Чому DuoSchool?",
            "panelBtn": "Обрати курс"
        },
        "auth": {
            "divider": "або",
            "google": "Google",
            "apple": "Apple",
            "facebook": "Facebook",
            "loginTitle": "Увійти",
            "loginDescription": "Введіть свої дані нижче, щоб увійти",
            "loginLabelName": "Електронна пошта / ім’я користувача",
            "loginLabelPassword": "Пароль",
            "loginPlaceholderName": "Введіть вашу електронну пошту / ім’я користувача",
            "loginPlaceholderPassword": "Введіть ваш пароль",
            "loginForgotPassword": "Забули пароль?",
            "loginAccount": "Немає акаунту?",
            "loginCreate": "Створити",
            "loginDenied": "Вы не можете увіти зараз",
            "nextBtn": "Продовжити",
            "prevBtn": "Назад",
            "create": "Створити акаунт",
            "haveAccount": "Вже є акаунт?",
            "login": "Увійти",
            "regTitle": "Новий акаунт",
            "regDescription": "Введіть свої дані нижче, щоб створити акаунт",
            "termsText": "Я погоджуюсь з",
            "termsLink": "Умовами та положеннями",
            "bloggerTitle": "Вибір блогера",
            "bloggerDescription": "Оберіть блогера для навчання вашим курсам",
            "bloggerSuggestion": "Магічна рекомендація",
            "pwStrWeak": "Слабкий",
            "pwStrMedium": "Середній",
            "pwStrStrong": "Сильний",
            "pwStrVStrong": "Дуже сильний",
            "pwStrEmpty": "Немає пароля",
            "labelName": "Повне ім’я",
            "labelUsername": "Ім’я користувача",
            "labelEmail": "Електронна пошта",
            "labelPhone": "Номер телефону",
            "labelTelegram": "Ім’я користувача в Telegram",
            "labelTelegramOpt": "Необов’язково",
            "labelTelegramDesc": "Отримуйте монети в телеграм-грі та переводьте їх на баланс DuoCrypto для придбання курсів.",
            "labelPassword": "Пароль",
            "labelPasswordConfirmation": "Підтвердіть пароль",
            "labelPasswordDesc": "Пароль повинен містити не менше 8 символів.",
            "labelGender": "Стать",
            "labelBirthday": "Дата народження",
            "labelCountry": "Країна",
            "labelCity": "Місто",
            "placeholderName": "Повне ім’я",
            "placeholderUsername": "Ім’я користувача",
            "placeholderEmail": "Введіть вашу електронну пошту",
            "placeholderPhone": "Введіть ваш номер телефону",
            "placeholderTelegram": "Ім’я користувача",
            "placeholderPassword": "Введіть ваш пароль",
            "placeholderPasswordConfirmation": "Введіть ваш пароль",
            "placeholderGender": "Оберіть вашу стать",
            "placeholderBirthday": "00 - 00 - 0000",
            "placeholderCountry": "Ваша країна",
            "placeholderCity": "Ваше місто",
            "errName": "Повне ім’я обов’язкове",
            "errName2": "Ім’я користувача може містити лише латинські літери та цифри.",
            "errNameLength": "Поле повинно містити від 3 до 16 символів.",
            "errUsername": "Ім’я користувача обов’язкове",
            "errUsername2": "Ім’я користувача може містити лише латинські літери, цифри та підкреслення.",
            "errUsernameLength": "Поле повинно містити від 3 до 16 символів.",
            "errEmail": "Електронна пошта обов’язкова",
            "errEmail2": "Електронна пошта повинна бути дійсною",
            "errEmail3": "Електронна пошта повинна бути дійсною",
            "errEmail4": "Електронна пошта не може бути порожньою",
            "errPhone": "Номер телефону обов’язковий",
            "errPhoneInvalid": "Неправильний номер телефону",
            "errPassword": "Пароль обов’язковий",
            "errPasswordShort": "Пароль повинен містити не менше 8 символів",
            "errPassword2": "Пароль повинен містити щонайменше одну велику літеру та цифру.",
            "errPasswordConfirmation": "Паролі не співпадають",
            "errGender": "Стать обов’язкова",
            "errBirthday": "Дата народження обов’язкова",
            "errInvalidBirthday": "Формат дати вашого народження некоректний, будь ласка, виправте його",
            "errFutureBirthday": "Дата вашого народження некоректна, будь ласка, введіть правильну дату",
            "errCountry": "Країна обов’язкова",
            "errCity": "Місто обов’язкове",
            "errTerms": "Ви повинні погодитися з умовами",
            "confirmPwdTitle": "Підтвердіть пароль",
            "confirmPwdText": "Будь ласка, підтвердіть ваш пароль перед продовженням",
            "confirmPwdLabel": "Пароль",
            "confirmPwdPlaceholder": "Введіть ваш пароль",
            "confirmPwdBtn": "Підтвердити",
            "verifyEmailTitle": "Підтвердіть вашу електронну пошту",
            "verifyMsg": "Ми надіслали посилання на",
            "verifyComplete": "Перейдіть за посиланням для завершення перевірки.",
            "verifyComplete1": "Можливо, вам потрібно буде перевірити папку Спам.",
            "verifyCodeSend": "Надіслати код повторно",
            "forgotPwdTitle": "Забули пароль?",
            "forgotPwdText": "Введіть вашу електронну пошту, щоб ми могли надіслати посилання для скидання пароля",
            "forgotPwdLabel": "Електронна пошта",
            "forgotPwdPlaceholder": "Введіть вашу пошту",
            "forgotPwdReset": "Скидання пароля",
            "forgotPwdLogin": "Повернутися до входу",
            "resetEmailLabel": "Електронна пошта",
            "resetPwdLabel": "Пароль",
            "resetConfirmPwdLabel": "Підтвердіть пароль",
            "resetEmailPlaceholder": "Введіть вашу пошту",
            "resetPwdPlaceholder": "Введіть ваш пароль",
            "resetConfirmPwdPlaceholder": "Введіть ваш пароль",
            "resetPwdReset": "Оновити пароль",
            "resetPwdLogin": "Повернутися до входу",
            "upMenuProfile": "Профіль",
            "upMenuNotifications": "Сповіщення",
            "upUpdated": "Ваші налаштування оновлені",
            "usRemovePhoto": "Видалити фото",
            "usUnverified": "Ваша електронна пошта не підтверджена.",
            "usUnverifiedReSend": "Натисніть тут, щоб повторно надіслати лист для підтвердження.",
            "usUnverifiedLink": "Нове посилання для підтвердження було надіслано на вашу електронну пошту.",
            "usSave": "Зберегти",
            "usPlayGame": "Грати в Перегони",
            "unTitle": "Сповіщення та Мотивація",
            "unMotivationTitle": "Мотиваційні повідомлення",
            "unMotivationText": "Ці повідомлення будуть надсилатися на вашу електронну пошту, щоб нагадати вам завершити проходження курсу",
            "unBonusTitle": "Сповіщення про досягнення, бонуси",
            "unBonusText": "Коли ви отримаєте бонуси, вам прийде повідомлення про це на електронну пошту",
            "unNewsTitle": "Новини платформи та нові курси",
            "failed": "Ці облікові дані не збігаються з нашими записами.",
            "password": "Указаний пароль невірний.",
            "throttle": "Забагато спроб входу. Будь ласка, спробуйте ще раз через {seconds} секунд.",
            "Gender": {
                "MALE": "Чоловік",
                "FEMALE": "Жінка",
                "ALL": "Інше",
                "UNKNOWN": "Не вказано"
            }
        },
        "checkout": {
            "pmTitle": "Оберіть спосіб оплати",
            "pmDescription": "Будь ласка, оберіть спосіб оплати зараз, оскільки ви не зможете змінити його під час оформлення замовлення.",
            "pmMoneyTitle": "Сплатити в доларах",
            "pmMoneyDescription": "Вы можете оплатить курс обычными способами, но не забывайте, что у вас есть возможность",
            "pmCoinTitle": "Сплатити монетами платформи",
            "pmCoinDescription": "У вас есть возможность полностью оплатить курс с помощью кредитов платформы. Ниже вы увидите общую стоимость.",
            "pmCoinBalanceDescription": "Сумма, подлежащая оплате в монетах платформы:",
            "pmCoinBalance": "Баланс",
            "pmDiscount": "Розрахувати знижку",
            "pmChoose": "Обрати",
            "cpTitle": "Оформлення замовлення",
            "cpDesc": "Введіть свої дані нижче для придбання курсу",
            "cpBilling": "Платіжна інформація",
            "cpPayment": "Способи оплати",
            "cpPay": "Сплатити",
            "cpLabelName": "Повне ім’я",
            "cpPlaceholderName": "Введите ваше полное имя",
            "cpLabelCountry": "Країна",
            "cpPlaceholderCountry": "Ваша країна",
            "termsText": "Я погоджуюсь з",
            "termsLink": "Умови користування",
            "cardTitle": "Кредитна картка",
            "coins": "Монетки",
            "pcTitle": "Промокод",
            "pcPlaceholder": "Додати промокод",
            "pcButton": "Застосувати",
            "pcButtonSuccess": "Успішно",
            "ciTitle": "Ваш курс",
            "ciIncludesTitle": "Включає:",
            "ciIncludesDesc": "Доступ до курсу на",
            "ciSubtotal": "Проміжний підсумок:",
            "ciDiscount": "Знижка:",
            "ciTotal": "Загальна сума:",
            "ciInfo": "Ваш доступ до курсу оплачений на визначений період. Якщо ви не завершите курс за цей час, ви можете продовжити доступ, обравши один із доступних варіантів продовження."
        },
        "courses": {
            "learnMore": "Дізнатися більше",
            "showMore": "Показати більше",
            "loading": "Завантаження...",
            "coming": "Незабаром...",
            "button": "Купити зараз",
            "topSliderButton": "Купити",
            "coursesTop": "Топ курси",
            "coursesBannerTitle1": "Вигідні пакети для вас",
            "coursesBannerTitle2": "Знижки на курси",
            "coursesBannerTitle3": "Купуйте курси за монети платформи для перепродажу",
            "coursesBannerLink": "Дізнатися більше",
            "courseStudents": "Студенти",
            "courseLanguage": "Мова",
            "courseMultilingual": "Багатомовний",
            "courseCertificate": "Сертифікат",
            "courseAvailable": "Доступно",
            "courseNotAvailable": "Недоступно",
            "courseLessons": "Уроки",
            "courseDuration": "Тривалість",
            "courseDifficulty": "Складність",
            "courseTagsTitle": "Навички, які ви здобудете",
            "courseLessonTitle": "Уроки",
            "courseContentTitle": "Докладніше",
            "courseSliderTitle": "Люди також купують",
            "courseDiscount": "Калькулятор знижок",
            "courseDiscountText": "Вкажіть, скільки монет платформи ви готові витратити, і ми розрахуємо для вас знижку",
            "courseDiscountMax": "Максимальна сума, яку можна витратити:",
            "courseDiscountBalance": "Ваш баланс:",
            "courseDiscountDiscount": "Ваша знижка:",
            "courseDiscountUse": "Використати знижку",
            "courseDiscountLater": "Пізніше",
            "courseDiscountLogin": "Увійдіть, щоб скористатися знижкою",
            "courseDiscountQuantity": "Оберіть кількість:",
            "courseDiscountCoins": "Монети",
            "courseDiscountCoin": " монет",
            "courseBuy": "Купити курс",
            "courseBuyDesc": "Ваш доступ до курсу оплачений на 3 місяці. Якщо ви не завершите курс за цей час, ви можете подовжити доступ, обравши один з доступних варіантів подовження.",
            "coursePlatformTitle": "Використовуйте монети платформи під час купівлі курсу",
            "coursePlatformDesc": "Ви можете використати зароблені монети для знижки або повної оплати курсу",
            "lsTheory": "Теорія",
            "lsPractice": "Практика",
            "lsTest": "Тест",
            "lsLearned": "Теорію вивчено",
            "lsTestDone": "Тест завершено",
            "lsTestPassed": "Тест пройдено",
            "lsPracticeDone": "Практика пройдена",
            "lsPracticePassed": "Практика пройдена",
            "lsPracticeLocked": "Ви повинні переглянути відео до кінця та натиснути \"Теорію пройдено\", щоб отримати доступ до практики, а потім до наступних уроків...",
            "lsPracticeDoneHint": "Ця кнопка активується, щойно ви пройдете тест або всі слайди. Натисніть її, щоб отримати доступ до наступного уроку.",
            "lsLessonsLocked": "Кожен урок доступний лише після проходження попереднього",
            "lsTheoryError": "Ви повинні повністю переглянути відео",
            "lsModalTitle": "Чудова робота!",
            "lsModalDesc": "Продовжуйте в тому ж дусі та збирайте ще більше нагород!",
            "lsModalContent": "Ви завершили урок і заробили:",
            "lrpPurchased": "Нещодавно придбані",
            "lrpStartBtn": "Почати курс",
            "lrpShareBtn": "Поділитися",
            "lrpProgress": "У процесі",
            "lrpStudies": "Останні навчання",
            "lrpCompleted": "Пройдено",
            "lrpLessons": "Уроки",
            "lrpCourseBtn": "До курсу",
            "lrpLessonsTitle": "Останні курси",
            "lrpDescLessons": "Уроки:",
            "lrpValidPeriod": "Курс доступний до:",
            "lrpExtendPeriod": "Продовжити",
            "lrpDescSpent": "Витрачено:",
            "lrpDescTime": "Час:",
            "lrpDescTimePoint": "год",
            "lrpCoinsPoint": "до +",
            "lrpDescType": "Тип:",
            "lrpDescXp": "XP:",
            "lrpDescCoins": "Монети:",
            "lrpDescBtn": "Продовжити",
            "lrpDescBtnFinal": "Пройдено",
            "lrpSertificate": "Переглянути сертифікат",
            "lrpSertModalTitle": "Сертифікат проходження",
            "lrpSertModalDesc": "Ви можете завантажити сертифікат про проходження у будь-який час.",
            "lrpSertModalDownload": "Завантажити",
            "lrpSertModalShare": "Поділитися",
            "lrpCpProgress": "Прогрес",
            "lrpCpLessons": "Ваші уроки",
            "extendTitle": "Продовження курсу",
            "extendDesc": "Ви можете подовжити курс на певний термін, якщо не встигаєте його завершити.",
            "extendPeriod": "Оберіть період",
            "extendAmount": "Сума до сплати",
            "extendClose": "Пізніше",
            "extendContinue": "Перейти до оплати",
            "expiredTitle": "Доступ завершився",
            "expiredText": "На жаль, ваш доступ до цього курсу завершився. Ви можете подовжити його, обравши бажаний термін і сплативши відповідну суму. Будь ласка, оберіть період подовження, щоб продовжити навчання!",
            "expiredButton": "Продовжити",
            "tgTitle": "Хочеш платити <span class=\"text-grayscale-900\">менше</span>?",
            "tgDesc": "Заробляйте монети в нашій грі GraphDEX у Telegram і обмінюйте їх на курс або отримуйте знижку. <br><br>Щоб перевести зароблені монети в DuoSchool, просто підключіть свій Telegram-акаунт через розділ Налаштування на нашій платформі.",
            "tgBtn": "Перейти до Telegram",
            "qquiz": "Тест",
            "qduration": "Тривалість",
            "qquestions": "правильних відповідей",
            "qcorrect": "Правильна відповідь",
            "qcheck": "Перевірити",
            "qcontinue": "Продовжити",
            "qgotit": "Зрозуміло",
            "qback": "Повернутись до теорії",
            "qdone": "Тест завершено",
            "qserverError": "Помилка сервера",
            "psmTitle": "Перейти на платформу",
            "psmDesc": "Будь ласка, перейдіть на платформу, щоб застосувати отримані знання. Лише після цього кроку ви зможете перейти до наступного слайду.",
            "psmBtn": "Практика в дії",
            "psmClose": "Закрити",
            "practice": "Практика",
            "test": "Тест",
            "min": "хв",
            "ok": "ГАРАЗД",
            "psmCompleateDesc": "Ви успішно завершили практику",
            "Difficulty": {
                "BEGINNER": "Початківець",
                "MEDIUM": "Середній",
                "HARD": "Складний",
                "EXPERT": "Експерт"
            },
            "start": "СТАРТ",
            "finish": "ФІНІШ",
            "ProlongPeriod": {
                "ONE_MONTH": "1 місяць",
                "TWO_MONTH": "2 місяці",
                "TREE_MONTH": "3 місяці",
                "UNLIMITED": "Безстроково"
            },
            "lrpShareModalTitle": "Поділитися курсом",
            "lrpShareModalCopy": "Скопіювати промокод",
            "lrpShareModalCopySuccess": "Скопійовано",
            "lrpShareModalText01": "Ви можете скопіювати посилання і передати його тому, кому хочете подарувати курс:",
            "lrpShareModalText02": "Скопіюйте посилання з промокодом",
            "lrpShareModalText03": "Передайте посилання людині, якій ви хочете подарувати курс.",
            "lrpShareModalText04": "Отримувач може використати посилання після входу на Платформу",
            "lrpShareModalText05": "Як тільки посилання буде використано, ми надішлемо вам сповіщення.",
            "lrpShareModalLabel": "Промокод",
            "errorMsgAlreadyActivated": "Це посилання помилкове або вже було активовано.",
            "errrorMsgTitle": "Помилка"
        },
        "emails": {
            "verify_email_subject": "Підтвердіть свою електронну пошту",
            "verify_email_line": "Будь ласка, натисніть на кнопку нижче, щоб підтвердити свою електронну пошту.",
            "verify_email_action": "Підтвердити електронну пошту",
            "verify_email_no_action": "Якщо ви не створювали акаунт, жодних дій не потрібно.",
            "all_rights": "Всі права захищені.",
            "reset_password_subject": "Сповіщення про скидання пароля!!!",
            "reset_password_line": "Ви отримали цей лист, тому що ми отримали запит на скидання пароля для вашого акаунту.",
            "reset_password_action": "Скинути пароль",
            "reset_password_expiry": "Посилання на скидання пароля діє протягом {count} хвилин.",
            "reset_password_no_action": "Якщо ви не запитували скидання пароля, жодних дій не потрібно.",
            "greeting": {
                "default": "Вітаємо!",
                "error": "Упс!"
            },
            "regards": "З повагою",
            "subcopy": "Якщо у вас виникли проблеми з натисканням кнопки \"{actionText}\", скопіюйте та вставте URL нижче\nв адресний рядок вашого браузера:",
            "expired": "Доступ до курсу!",
            "prolongation": "Продовження доступу до курсу!"
        },
        "global": {
            "Today": "Сьогодні",
            "Yesterday": "Вчора",
            "PromoCodeHasBeenActivated": "Промокод активовано",
            "ThePromoCodeWasApplied": "Промокод {promo_code} був застосований.",
            "ContinueLearning": "Продовжити навчання",
            "langTitle": "Оберіть зручну мову навчання",
            "langError": "Ця мова не підтримується.",
            "langWarning": "Наші курси доступні російською та англійською мовами.</br> ШІ-асистент також працює цими двома мовами.</br> Зверніть увагу: підтримка української мови ІІ-аватаром поки що нестабільна — ми працюємо над покращенням якості.",
            "home": "Головна",
            "learning": "Навчання",
            "ranks": "Топ",
            "shop": "Магазин",
            "courses": "Курси",
            "referral": "Реферал",
            "settings": "Налаштування",
            "help": "Допомога",
            "logout": "Вийти",
            "profile": "Профіль",
            "btDashboard": "Панель управління",
            "btHelp": "Допомога",
            "btTokens": "API токени",
            "btCheckoutError": "Помилка при оформленні",
            "btCheckoutSuccess": "Оформлення успішне",
            "btCourses": "Курси",
            "btCourse": "Курс",
            "btLeaderboard": "Таблиця лідерів",
            "btLearningCourse": "Курс навчання",
            "btLearning": "Навчання",
            "btLesson": "Урок",
            "btShop": "Магазин",
            "btCertificate": "Сертифікат",
            "btReferrals": "Мої реферали",
            "btProfile": "Профіль",
            "btPrivacy": "Політика конфіденційності",
            "btTerms": "Умови та положення",
            "btCookies": "Політика використання cookies",
            "ncTitle": "У вас немає придбаних курсів",
            "ncText": "На жаль, у вас поки що немає придбаних курсів, тому тут немає доступного контенту. Придбайте курс, і ви отримаєте доступ до відповідної інформації на цій сторінці.",
            "ncButton": "Переглянути курси",
            "ibTitle": "Розпочати гонку",
            "ibText": "Заробити монети",
            "ibLink": "Гонка",
            "tabMenuJourney": "Подорож",
            "tabMenuCourses": "Топ курси",
            "tabMenuNews": "Новини",
            "title": "Ваша подорож у",
            "level": "Рівень",
            "coursesTitle": "Топ курси",
            "newsTitle": "Дізнайтесь більше про нас",
            "pShareArticle": "Поділитися",
            "pSimilarArticle": "Схожі статті",
            "refTitle": "Мої реферали",
            "refTitleTransactions": "Транзакції рефералів",
            "refTableName": "Реферали",
            "refTableBonus": "Бонус",
            "refTableDate": "Дата",
            "refInviteTitle": "Запросити друга",
            "refInviteText": "Отримайте <strong class=\"text-white font-bold\">10%</strong> з покупок друзів",
            "refInviteLink": "Скопіювати своє реферальне посилання",
            "refInviteCopySuccess": "Скопійовано",
            "refInviteCopyError": "Помилка копіювання",
            "refInviteOr": "або",
            "refInviteButton": "Показати QR",
            "refInviteBalance": "Баланс за покупки рефералів",
            "refInviteBalanceBtn": "Вивести",
            "refModalTitle": "QR код",
            "refModalDownload": "Завантажити QR",
            "refModalClose": "Закрити",
            "pagItems": "Елементи {from} - {to} з {total}",
            "pagShow": "Показати:",
            "topMenuDaily": "Денний",
            "topMenuWeekly": "Тижневий",
            "topMenuMonthly": "Місячний",
            "topStatHave": "У вас",
            "topStatHaveBtn": "Продовжити навчання",
            "topStatRank": "Ваш рейтинг",
            "topStatRankBtn": "Переглянути в лідерборді",
            "topTableSearch": "Пошук за ім’ям",
            "topTableRank": "Рейтинг",
            "topTableName": "Ім’я",
            "topTableCompleted": "Пройдені уроки",
            "topTableWin": "Бонус за вхід",
            "topTableTotal": "Всього XP",
            "pfCoin": "монет",
            "pfCoinLink": "Перейти до курсів",
            "pfXpLink": "Таблиця лідерів",
            "pfOverview": "Огляд",
            "pfOverAttendance": "Відвідуваність",
            "pfOverAttendanceDays": "днів",
            "pfOverCourses": "Курси",
            "pfOverCoursesDone": "завершено",
            "pfAttendanceTitle": "Відвідуваність",
            "pfAttendanceDesc": "Отримуйте щоденні нагороди. Якщо ви пропустите день, ваш прогрес буде скинуто.",
            "pfAttendanceDay": "День",
            "carModalTitle": "Ви просто молодець!",
            "carModalDesc": "Продовжуйте в тому ж дусі!",
            "carModalPrize": "Ось ваша нагорода:",
            "fAbout": "Про нас",
            "fPrivacy": "Політика конфіденційності",
            "fAgreement": "Умови та положення",
            "fCookie": "Політика використання cookie",
            "fCopy": "Всі права захищені DuoSchool.ai",
            "bePromoNotFound": "Промокод не знайдено",
            "bePromoMissing": "Відсутній номінал промокоду.",
            "bePromoExpired": "Промокод недійсний",
            "bePromoCourse": "Цей промокод може бути застосований лише до курсу",
            "bePromoCourseDenied": "Промокод не може бути застосований до поточного курсу",
            "bePromoCourseProlong": "Промокод не може бути застосований до подовження курсу",
            "beOrderItem": "Товар не знайдено",
            "beOrderUser": "Користувача не знайдено",
            "beCoinsOrder": "Недостатньо монет для цього замовлення.",
            "beCheckoutEmpty": "Кошик порожній",
            "beCheckoutOrder": "Замовлення не знайдено",
            "beCheckoutMissing": "Відсутня причина невдалої спроби оплати.",
            "beCourseNotFound": "Курс не знайдено",
            "beCourseStarted": "Курс вже розпочато.",
            "beCourseNotStarted": "Ми не можемо розпочати курс без уроків.",
            "beCourseCoursePlan": "Неможливо придбати план курсу зараз",
            "beCartAdd": "Неможливо додати товар до кошика",
            "beCartPayment": "Неможливо отримати способи оплати",
            "beCartEmpty": "Ваш кошик порожній.",
            "beCartMissingPM": "Відсутній спосіб оплати",
            "beCartCreateSession": "Не вдалося створити сесію оформлення замовлення",
            "beCartPromoMissed": "Відсутній промокод",
            "beCartPromoUsed": "Промокод вже використано",
            "beLearningCourse": "Відсутній курс користувача.",
            "beLearningStart": "Ми не можемо розпочати цей курс зараз, будь ласка, зверніться до служби підтримки.",
            "beLessonView": "Ви не можете переглядати цей урок.",
            "beLessonSlideId": "Відсутній ідентифікатор слайду",
            "beLessonSlideProcess": "Не вдалося обробити слайд галереї.",
            "beLessonAnswerCheck": "Не вдалося перевірити відповідь на запитання.",
            "beLessonTheoryFail": "Не вдалося завершити теорію, спробуйте ще раз або зверніться до служби підтримки.",
            "beLessonPracticeFail": "Не вдалося завершити практику, спробуйте ще раз або зверніться до служби підтримки.",
            "dailyModalTitle": "Оновлення заробітку",
            "dailyModalDesc": "Ви заробили за вхід у систему на ваш {day}-й підряд день! Продовжуйте в тому ж дусі, щоб отримати ще більше нагород!",
            "dailyModalPrize": "Ось ваша нагорода:",
            "portugal": "Португалія",
            "leaderBoardPeriod": "Статистика оновлюється щогодини.",
            "certTitle": "Сертифікат про проходження",
            "certDesc": "Цей сертифікат підтверджує, що студент успішно пройшов курс",
            "certDesc2": "",
            "headerNotify": "Додайте ваше ім’я до профілю для отримання сертифікатів.",
            "headerNotifyLink": "Змінити профіль.",
            "helpBannerTitle": "Не знайшли відповідь?",
            "helpBannerDesc": "Напишіть нам своє запитання на будь-якій зручній платформі. Ми відповімо якнайшвидше.",
            "HelpTopics": {
                "ALL": "Усі",
                "SETTINGS": "Профіль",
                "PLATFORM": "Курси",
                "AI": "Про проєкт",
                "FAQ": "Часті запитання"
            }
        },
        "lp": {
            "navCourse": "Курси",
            "navAbout": "Про нас",
            "navNews": "Блог",
            "login": "Увійти",
            "register": "Почати зараз",
            "subscribe": "Підпишіться на нашу розсилку",
            "emailPalceholder": "Електронна пошта",
            "navigation": "Навігація",
            "policies": "Правила",
            "courses": "Курси",
            "about": "Про нас",
            "news": "Новини",
            "cookie": "Політика використання файлів cookie",
            "privacy": "Політика конфіденційності",
            "agreement": "Правила та умови",
            "contacts": "Зв’язатися з нами",
            "copy": "© 2025 — DuoSchool",
            "courseTitle": "Найкращі курси",
            "courseBuy": "Купити зараз",
            "bTitle": "Вивчайте нові <span class=\"text-primary-500\">навички</span> разом з улюбленими блогерами та експертами",
            "bText": "Ми зібрали найкращі освітні програми з ШІ та криптовалют в одному місці спеціально під ваші потреби. Отримуйте сертифікати, діліться досвідом, заробляйте бонуси та беріть участь у нашій реферальній програмі.",
            "bButton": "Як це працює?",
            "lpNotes": "Курси з ШІ та криптовалют",
            "lpWidget": "Вбудовані віджети для практики",
            "lpCursor": "Інтерактивне навчання",
            "lpSale": "Бонусні бали за досягнення",
            "lpCup": "Мотиваційний рейтинг",
            "lpGamepad": "Випадкова бонусна гра",
            "mTitle": "Опановуйте найзатребуваніші навички в ШІ та криптовалютах",
            "mTitle1": "Криптовалюта",
            "mText1": "Блокчейн і криптовалюта змінили наше уявлення про фінанси. Зі зростанням крипторинку розуміння його особливостей стає надзвичайно важливим. Почніть з наших курсів з основ крипти, а потім переходьте до складніших програм з трейдингу на CEX, DEX, мем-коїнах і ретродропах.",
            "mBtn1": "Обрати курс",
            "mTitle2": "Штучний інтелект",
            "mText2": "Розуміння ШІ більше не є опцією — це необхідність у світі, де технології керують усім. З нашими курсами ви почнете з основ, а потім перейдете до спеціалізованих тем з ШІ-відео, зображень і текстів. Навчання проводять віртуальні експерти, створені на основі ШІ.",
            "mBtn2": "Обрати курс",
            "sTitle": "Улюбленець студентів",
            "sBlockTitle": "Стартовий",
            "sBlockText": "Наш курс занурить вас у світ криптовалют і блокчейна з нуля, допомагаючи освоїти не лише теорію, а й отримати практичний досвід. Ми починаємо з основ: ви дізнаєтесь, що таке криптовалюти, як вони працюють, їхню роль у сучасній економіці та чому за ними майбутнє фінансів.",
            "sBlockPrimaryBtn": "Почати зараз",
            "sBlockSecondaryBtn": "Дізнатися більше",
            "jTitle": "Ваш шлях навчання",
            "jTabTitle1": "Теоретична частина",
            "jTabContent1": "Навчайтеся за допомогою зрозумілих відеоуроків, що створюють міцну базу знань.",
            "jTabTitle2": "Практична частина",
            "jTabContent2": "Застосовуйте знання на практиці через реальні завдання та кейси.",
            "jTabTitle3": "Заробіток бонусів",
            "jTabContent3": "Отримуйте нагороди під час проходження курсу — за виконання завдань і досягнення цілей.",
            "jTabTitle4": "Витрати монет",
            "jTabContent4": "Обмінюйте зароблені монети на ексклюзивні нагороди.",
            "tTitle": "",
            "tText": "Хочете навчатися на вигідних умовах? Відвідайте бота наших партнерів і отримайте курс. Не проґавте ексклюзивну пропозицію.",
            "tBtn": "Перейти до Telegram",
            "lTitle1": "Заощаджуйте з нашими пакетами курсів",
            "lText1": "Зануртесь у світ криптовалют і ШІ за вигідною ціною",
            "lTitle2": "Заробляйте з нашою реферальною програмою",
            "lText2": "Запрошуйте друзів навчатися на нашій платформі та отримуйте кешбек!",
            "lTitle3": "Відкривайте знижки за монети!",
            "lText3": "Використовуйте монети платформи, щоб заощаджувати на курсах.",
            "lMore": "Дізнатися більше",
            "cTitle": "Чому варто обрати саме наші курси?",
            "cText": "Ми поєднуємо теорію, практику та захопливу систему нагород, щоб ви здобули корисні навички для викликів у сфері ШІ та криптовалют.",
            "cBtn": "Обрати курс",
            "cTitle1": "Багато мов",
            "cText1": "Оберіть будь-яку мову й навчайтесь без потреби постійного перекладу.",
            "cTitle2": "Експерти ШІ",
            "cText2": "Наші віртуальні експерти на базі ШІ покажуть вам, як стати профі у крипті та ШІ.",
            "cTitle3": "Реферальна програма",
            "cText3": "Отримуйте бонуси за запрошення друзів на платформу й обмінюйте їх на класні нагороди.",
            "cTitle4": "Практична частина",
            "cText4": "Теорія важлива, але ми покажемо, як застосовувати знання на практиці.",
            "cTitle5": "Повноцінні курси",
            "cText5": "Ми пропонуємо найкращі курси з ШІ та криптовалют, поєднуючи наш досвід із передовими методиками навчання.",
            "aTitle": "Часті запитання",
            "oTitle": "Залишились питання?",
            "oText": "Якщо у вас залишились питання — напишіть нам. Ми тут, щоб допомогти вам досягти успіху.",
            "oBtn": "Зв’язатися з нами",
            "aQuestion1": "Чи підходять курси для новачків, чи потрібні попередні знання?",
            "aAnswer1": "Наші курси розраховані на новачків. Ви можете почати з основ і поступово перейти до складніших тем.",
            "aQuestion2": "Як заробляти та використовувати бонуси й монети на платформі?",
            "aAnswer2": "Ви отримуєте бонуси за виконання завдань і досягнення цілей. Їх можна обміняти на знижки, призи, покращення в грі та інше.",
            "aQuestion3": "Який сертифікат я отримаю після проходження курсу?",
            "aAnswer3": "Ви отримаєте цифровий сертифікат про завершення курсу.",
            "aQuestion4": "Як взяти участь у реферальній програмі та які переваги?",
            "aAnswer4": "Наша реферальна програма дозволяє отримувати 10% від суми, витраченої вашими друзями на курси. Запрошуйте друзів і використовуйте бонуси як забажаєте!",
            "aQuestion5": "Чи зможу я отримати доступ до матеріалів після завершення курсу?",
            "aAnswer5": "Так, матеріали доступні протягом певного часу після завершення курсу. Щоб продовжити доступ, потрібно буде внести додаткову оплату.",
            "newsTitle": "Читайте новини у нашому блозі",
            "newsMore": "Читати далі",
            "newPreheader": "Ми дотримуємось міжнародного права та етичних норм, не співпрацюючи з країнами, що ведуть агресивну політику.",
            "newBannerExtraTitle": "DuoSchool",
            "newBannerTitle": "ваш провідник у навчанні нового покоління",
            "newBannerCheck01": "Навчання від ШІ",
            "newBannerCheck02": "Улюблене всіма",
            "newBannerBtnStart": "Почати безкоштовно",
            "newBannerBtnLearn": "Дізнатися більше",
            "partnersTitle": "Ці компанії",
            "partnersExtraTitle": "співпрацюють з нами",
            "partnersText1": "— лідер у світі криптовалют з більш ніж <span class=\"text-accent\">250 мільйонами користувачів у 180+ країнах</span>",
            "partnersText2": "— одна з провідних бірж цифрових активів, якій довіряють понад <span class=\"text-accent\">30 мільйонів користувачів у 170+ країнах</span>",
            "partnersText3": "— інноваційна компанія, що спеціалізується на MEV, з більш ніж <span class=\"text-accent\">150 успішними токенами</span> та інтеграціями на 100+ DEX і CEX.",
            "partnersText4": "— платформа для створення графіків з аналітичними інструментами та соцмережею з більш ніж <span class=\"text-accent\">50 мільйонів трейдерів</span> і інвесторів.",
            "partnersText5": "— провідна аналітична платформа, яка <span class=\"text-accent\">надає дані в реальному часі</span> і аналітичні огляди щодо <span class=\"text-accent\">DeFi-сектору</span>.",
            "partnersText6": "— друга за обсягом торгів криптобіржа з величезною спільнотою з понад <span class=\"text-accent\">60 мільйонів користувачів</span> у всьому світі",
            "countdownTitle": "Відкрийте вигідні пропозиції на курси з крипти",
            "countdownText": "Підпишіться на нашого Telegram-бота і отримайте ексклюзивну знижку на криптокурси!",
            "countdownBtn": "Отримати знижку",
            "countdownDay": "д",
            "countdownHour": "г",
            "countdownMin": "хв",
            "countdownSec": "с",
            "perfectCoursesTitle": "Наші курси ідеально підходять для:",
            "perfectCoursesItemTitle1": "Новачків, які хочуть зануритися в крипту та ШІ",
            "perfectCoursesItemText1": "Вважаєте, що це складно? Тільки не з нами! Ми допоможемо вам опанувати основи, покажемо, як отримати перший прибуток і вбережемо від типових помилок.",
            "perfectCoursesItemTitle2": "Тих, хто хоче прокачати навички",
            "perfectCoursesItemText2": "Опануйте просунуті стратегії трейдингу та ШІ, які допоможуть стабільно заробляти до $2000 і впевнено почуватися на ринках, що стрімко розвиваються.",
            "perfectCoursesItemTitle3": "Тих, хто хоче бути на крок попереду",
            "perfectCoursesItemText3": "Опануйте затребувані навички у блокчейні та ШІ, які відкриють перед вами нові можливості. Заробляйте до $3000 і розкривайте свій потенціал без обмежень!",
            "perfectCoursesItemBtn": "Переглянути курс",
            "certificationTitle": "Отримайте сертифікат!",
            "certificationText": "Завершіть курс і підтвердіть свій досвід",
            "certificationBtn": "Знайти курс",
            "leaderboardTitle": "Підіймайтесь у рейтингу та отримуйте ексклюзивні бонуси!",
            "leaderboardText": "Щотижня та щомісяця 3 найкращих студенти отримують особливі нагороди. Наприклад:",
            "leaderboardBtn": "Детальніше",
            "leaderboardBlockTitle1": "Заробляйте з нашою реферальною програмою",
            "leaderboardBlockText1": "Запрошуйте друзів навчатися на платформі та отримуйте кешбек!",
            "leaderboardBlockTitle2": "Відкривайте знижки за монети!",
            "leaderboardBlockText2": "Використовуйте монети платформи, щоб заощадити на курсах.",
            "pTestimonialTitle": "Експертна підтримка та вебінари від:",
            "pTestimonialText1": "Алекс, засновник і CEO Peanut Trade, має понад десять років досвіду в IT та з 2013 року активно працює у блокчейн-сфері.",
            "pTestimonialText2": "Він брав участь в ICO Ethereum, а у 2014 році запустив BitX — стартап, який дозволяв оплачувати телеком та інші послуги біткоїнами. Також він майнив біткоїн з 2015 року і брав участь у створенні українських майнерів Hotmine на чіпах Bitfury.",
            "pTestimonialText3": "Алекс успішно залучив понад $30 мільйонів для трьох проєктів: Remme, Hackless та Peanut Trade. З 2015 року займається майнінгом і входить до правління Bitcoin Foundation Ukraine.",
            "pTestimonialText4": "Крім того, він є членом робочої групи з підготовки законодавства про криптовалюти в Україні.",
            "pTestimonialName": "Алекс Момот",
            "pTestimonialJob": "Засновник і CEO Peanut Trade",
            "opTitle": "Відкрийте для себе неймовірні можливості навчання!",
            "opBtn": "Почніть зараз безкоштовно",
            "opContentTitleB1": "Гнучкість",
            "opContentB1Text1": "Структуровані курси – Теорія і практика",
            "opContentB1Text2": "Можливість навчатися у своєму темпі – будь-коли і будь-де",
            "opContentB1Text3": "Обирайте зручну мову навчання",
            "opContentB1Text4": "Досвід не потрібен, підходить для початківців",
            "opContentB1Text5": "Доступ до каналу в Discord",
            "opContentTitleB2": "Підтримка",
            "opContentB2Text1": "Цілодобова підтримка з ШІ-агентами ",
            "opContentB2Text2": "Підтримка менторів",
            "opContentB2Text3": "Регулярні вебінари та AMA-сесії з експертами",
            "opContentTitleB3": "Спільнота",
            "opContentB3Text1": "Дружня міжнародна спільнота",
            "opContentB3Text2": "Таблиця лідерів та ігри на платформі",
            "opContentB3Text3": "Унікальні NFT для найкращих студентів",
            "opContentTitleB4": "Розширені можливості",
            "opContentB4Text1": "Просунуті стратегії та аналітика у трейдингу",
            "opContentB4Text2": "Бонуси та знижки на нові курси",
            "opContentB4Text3": "Вибір мови навчання",
            "opContentB4Text4": "Сертифікат після завершення курсу",
            "opContentB4Text5": "Чудова реферальна програма",
            "studentsTitle": "студентів вже навчаються з нами",
            "studentsBtn": "Почніть зараз безкоштовно",
            "catTitle": "Оберіть курс, що найкраще відповідає вашим потребам",
            "catCouseTitle00": "Криптовалюта для початківців",
            "catCouseTitle01": "Торгівля мемкоїнами: від теорії до практики",
            "catCouseTitle02": "Трейдинг: від теорії до практики",
            "catCouseTitle03": "Штучний інтелект для початківців",
            "catCouseTitle04": "Просунутий ШІ: від теорії до майстерності",
            "catCouseTopicCrypto": "Крипто Курс",
            "catCouseTopicTrading": "Трейдинг Курс",
            "catCouseTopicAi": "ШІ Курс",
            "catCouseBtn": "Обрати варіант",
            "catCryptoTitle": "Курси з криптовалют",
            "catAiTitle": "Курси зі штучного інтелекту",
            "lModalTitle": "Уроки",
            "tradingHeroTitle": "Трейдинг: від теорії до практики",
            "tradingHeroText1": "Трейдинг може здатися складним, але повірте — це зовсім не обов’язково так.",
            "tradingHeroText2": "На цьому курсі ми почнемо з основ і крок за кроком розвиватимемо ваші навички. Вас чекає збалансоване поєднання теорії та практики, щоб ви не просто навчались, а готувалися до реальних дій! До кінця курсу ви почуватиметесь набагато впевненіше на фінансових ринках — як у класичних активах, так і у захопливому світі криптовалют.",
            "tradingHeroText3": "Цей курс ідеально підійде як повним новачкам, так і тим, хто вже пробував трейдинг, але не знає, як рухатись далі. А також для тих, хто розглядає трейдинг як повноцінну професію.",
            "tradingOptions": "Оберіть варіант",
            "tradingOptionsReviews": "відгуків",
            "tradingOptionsDuration": "Тривалість:",
            "tradingOptionsHour": "год",
            "tradingOptionsMinute": "хв",
            "tradingOptionsExperts": "Експерти:",
            "tradingOptionsExpertsName": "ШІ Алекс та Емма",
            "tradingOptionsEarn": "Дохід:",
            "tradingOptionsEarnTo": "До",
            "tradingOptionsIncluded": "Що входить до курсу",
            "tradingOptionsListBtn": "Переглянути уроки",
            "tradingOptionsBuy": "Купити зараз",
            "tradingOptionsTitle1": "Базовий",
            "tradingOptionsTitle2": "Середній",
            "tradingOptionsTitle3": "Профі",
            "tradingOptionsList01Item01": "Доступ до курсу на 1 місяць",
            "tradingOptionsList01Item02": "27 уроків",
            "tradingOptionsList01Item03": "Участь у рейтингу",
            "tradingOptionsList01Item04": "Базова підтримка",
            "tradingOptionsList01Item05": "Безкоштовні PDF-матеріали",
            "tradingOptionsList02Item01": "Доступ до курсу на 1 місяць",
            "tradingOptionsList02Item02": "Усі 54 уроки",
            "tradingOptionsList02Item03": "Участь у рейтингу",
            "tradingOptionsList02Item04": "Базова підтримка",
            "tradingOptionsList02Item05": "Безкоштовні PDF-матеріали",
            "tradingOptionsList02Item06": "Сертифікат",
            "tradingOptionsList02Item07": "Безкоштовні вебінари",
            "tradingOptionsList02Item08": "Доступ до приватної спільноти на 1 місяць",
            "tradingOptionsList02Item09": "AMA-сесії",
            "tradingOptionsList03Item01": "Доступ до курсу на 3 місяці",
            "tradingOptionsList03Item02": "Усі 54 уроки",
            "tradingOptionsList03Item03": "Участь у рейтингу",
            "tradingOptionsList03Item04": "Цілодобова підтримка ШІ",
            "tradingOptionsList03Item05": "Набір PDF-матеріалів",
            "tradingOptionsList03Item06": "Сертифікат",
            "tradingOptionsList03Item07": "Додаткові відео кожні 2 тижні",
            "tradingOptionsList03Item08": "Доступ до приватної спільноти на 3 місяці",
            "tradingOptionsList03Item09": "Щомісячні AMA-сесії з лідерами криптоіндустрії",
            "tradingOptionsList03Item10": "Щотижневі AMA-сесії з кураторами",
            "tradingOptionsList03Item11": "Унікальний NFT",
            "tradingOptionsList03Item12": "Можливість працевлаштування в провідні криптокомпанії світу",
            "tradingOptionsList03Item13": "Доступ до бета-версій нових інструментів і сервісів",
            "tradingSureTitle": "Не впевнені, що цей курс для вас?",
            "tradingSureText": "Ознайомтеся зі списком уроків, а щоб переконатись напевно — пройдіть кілька уроків БЕЗКОШТОВНО! Оцініть самі, наскільки цінний та зручний у нас курс.",
            "tradingSureBtn": "Почати безкоштовно",
            "tradingReviewTitle": "Надихайтесь",
            "tradingReviewText": "Дізнайтеся, як інші студенти змінили свою кар’єру та життя з DuoSchool",
            "tradingAlsoBuyTitle": "Також купують",
            "memeHeroTitle": "Трейдинг мем-коїнів: від теорії до практики",
            "memeHeroText1": "Цікавитесь ажіотажем навколо мем-коїнів? Цей курс допоможе вам розібратись у цій захоплюючій ніші крипторинку!",
            "memeHeroText2": "Ви дізнаєтесь, як ефективно аналізувати мем-коїни, знаходити потенційних переможців і орієнтуватися в нестабільному ринковому середовищі.",
            "memeHeroText3": "Будь ви новачок, повний цікавості, або трейдер, що хоче підсилити свій портфель — цей курс дасть цінні знання, які можуть примножити ваші інвестиції.",
            "memeOptionsList01Item01": "Доступ до курсу на 1 місяць",
            "memeOptionsList01Item02": "17 уроків",
            "memeOptionsList01Item03": "Участь у рейтингу",
            "memeOptionsList01Item04": "Базова підтримка",
            "memeOptionsList01Item05": "Безкоштовні PDF-матеріали",
            "memeOptionsList02Item01": "Доступ до курсу на 1 місяць",
            "memeOptionsList02Item02": "Усі 38 уроків",
            "memeOptionsList02Item03": "Участь у рейтингу",
            "memeOptionsList02Item04": "Базова підтримка",
            "memeOptionsList02Item05": "Безкоштовні PDF-матеріали",
            "memeOptionsList02Item06": "Сертифікат",
            "memeOptionsList02Item07": "Безкоштовні вебінари",
            "memeOptionsList02Item08": "Доступ до приватної спільноти на 1 місяць",
            "memeOptionsList02Item09": "AMA-сесії",
            "memeOptionsList03Item01": "Доступ до курсу на 3 місяці",
            "memeOptionsList03Item02": "Усі 38 уроків",
            "memeOptionsList03Item03": "Участь у рейтингу",
            "memeOptionsList03Item04": "Цілодобова підтримка ШІ",
            "memeOptionsList03Item05": "Набір PDF-матеріалів",
            "memeOptionsList03Item06": "Додаткові відеоматеріали щотижня",
            "memeOptionsList03Item07": "Сертифікат",
            "memeOptionsList03Item08": "Доступ до приватної спільноти на 3 місяці",
            "memeOptionsList03Item09": "Щомісячні AMA-сесії з лідерами криптоіндустрії",
            "memeOptionsList03Item10": "Щотижневі AMA-сесії з кураторами",
            "memeOptionsList03Item11": "Унікальний NFT",
            "memeOptionsList03Item12": "Можливість працевлаштування в провідні криптокомпанії світу",
            "starterHeroTitle": "Криптовалюта для початківців",
            "starterHeroText1": "Якщо ви чули про криптовалюти та блокчейн, але не знаєте, з чого почати — цей курс створений для вас! Ми пояснимо все — від основ до практичних знань, щоб ви могли повноцінно зрозуміти, як працюють криптовалюти і чому вони формують майбутнє фінансів.",
            "starterHeroText2": "До завершення курсу ви чітко зрозумієте, що таке крипта, яка її роль у світовій економіці і чому це не просто модний тренд.",
            "starterHeroText3": "Цей курс чудово підійде всім, хто хоче нарешті розібратися у світі крипти та відкрити для себе захопливі можливості заробітку за допомогою цифрових валют.",
            "starterOptionsList01Item01": "Доступ до курсу на 1 місяць",
            "starterOptionsList01Item02": "19 уроків",
            "starterOptionsList01Item03": "Участь у рейтингу",
            "starterOptionsList01Item04": "Базова підтримка",
            "starterOptionsList02Item01": "Доступ до курсу на 3 місяці",
            "starterOptionsList02Item02": "19 уроків",
            "starterOptionsList02Item03": "Участь у рейтингу",
            "starterOptionsList02Item04": "Особиста підтримка 24/7",
            "starterOptionsList02Item05": "Сертифікат",
            "starterOptionsList02Item06": "Набір PDF-матеріалів",
            "starterOptionsList02Item07": "Додаткові відеоматеріали кожні 2 тижні",
            "starterOptionsList02Item08": "Можливість заробітку",
            "beginerCourseDifficulty": "Середній",
            "beginerCourseTitle": "Стартовий",
            "beginerCourseType": "Трейдинг Курс",
            "beginerCourseBtn": "Обрати варіант",
            "tradeCourseDifficulty": "Складний",
            "tradeCourseTitle": "Трейдинг",
            "tradeCourseType": "Трейдинг Курс",
            "tradeCourseBtn": "Обрати варіант",
            "memeCourseDifficulty": "Складний",
            "memeCourseTitle": "Мемкоїни",
            "memeCourseType": "Крипто Курс",
            "memeCourseBtn": "Обрати варіант"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Пароль повинен містити щонайменше шість символів і збігатися з підтвердженням.",
            "reset": "Ваш пароль встановлено!",
            "sent": "Посилання для відновлення пароля надіслано!",
            "token": "Невірний код скидання пароля.",
            "user": "Користувача з указаною електронною адресою не знайдено."
        },
        "validation": {
            "accepted": "Ви повинні прийняти {attribute}.",
            "active_url": "Поле {attribute} має бути коректним URL.",
            "after": "Поле {attribute} має бути датою після {date}.",
            "after_or_equal": "Поле {attribute} має бути датою, що дорівнює або пізніше {date}.",
            "alpha": "Поле {attribute} може містити лише літери.",
            "alpha_dash": "Поле {attribute} може містити лише літери, цифри, дефіс і підкреслення.",
            "alpha_num": "Поле {attribute} може містити лише літери та цифри.",
            "array": "Поле {attribute} має бути масивом.",
            "before": "Поле {attribute} має бути датою до {date}.",
            "before_or_equal": "Поле {attribute} має бути датою, що дорівнює або раніше {date}.",
            "between": {
                "numeric": "Поле {attribute} повинно бути між {min} та {max}.",
                "file": "Розмір файлу в полі {attribute} має бути від {min} до {max} кілобайт.",
                "string": "Поле {attribute} повинно містити від {min} до {max} символів.",
                "array": "Поле {attribute} повинно містити від {min} до {max} елементів."
            },
            "boolean": "Поле {attribute} повинно бути true або false.",
            "confirmed": "Поле {attribute} не збігається з підтвердженням.",
            "date": "Поле {attribute} не є дійсною датою.",
            "date_format": "Поле {attribute} не відповідає формату {format}.",
            "different": "Поля {attribute} та {other} повинні відрізнятися.",
            "digits": "Поле {attribute} повинно містити {digits} цифр.",
            "digits_between": "Поле {attribute} повинно містити від {min} до {max} цифр.",
            "dimensions": "Поле {attribute} має недійсні розміри зображення.",
            "distinct": "Поле {attribute} містить повторюване значення.",
            "email": "Поле {attribute} повинно бути дійсною електронною адресою.",
            "exists": "Обране значення для {attribute} недійсне.",
            "file": "Поле {attribute} повинно бути файлом.",
            "filled": "Поле {attribute} є обов’язковим для заповнення.",
            "image": "Поле {attribute} повинно бути зображенням.",
            "in": "Обране значення для {attribute} є недійсним.",
            "in_array": "Поле {attribute} не існує в {other}.",
            "integer": "Поле {attribute} повинно бути цілим числом.",
            "ip": "Поле {attribute} повинно бути дійсною IP-адресою.",
            "ipv4": "Поле {attribute} повинно бути дійсною IPv4-адресою.",
            "ipv6": "Поле {attribute} повинно бути дійсною IPv6-адресою.",
            "json": "Поле {attribute} повинно бути валідним JSON рядком.",
            "max": {
                "numeric": "Поле {attribute} не повинно перевищувати {max}.",
                "file": "Поле {attribute} не повинно перевищувати {max} кілобайт.",
                "string": "Поле {attribute} повинно містити не більше {max} символів.",
                "array": "Поле {attribute} повинно містити не більше {max} елементів."
            },
            "mimes": "Поле {attribute} повинно бути файлом одного з типів: {values}.",
            "mimetypes": "Поле {attribute} повинно бути файлом одного з типів: {values}.",
            "min": {
                "numeric": "Поле {attribute} повинно бути не менше {min}.",
                "file": "Поле {attribute} повинно бути не менше {min} кілобайт.",
                "string": "Поле {attribute} повинно містити щонайменше {min} символів.",
                "array": "Поле {attribute} повинно містити щонайменше {min} елементів."
            },
            "not_in": "Обране значення для {attribute} є некоректним.",
            "numeric": "Поле {attribute} повинно бути числом.",
            "present": "Поле {attribute} повинно бути присутнім.",
            "regex": "Поле {attribute} має неправильний формат.",
            "required": "Поле {attribute} є обов’язковим.",
            "required_if": "Поле {attribute} є обов’язковим, коли {other} дорівнює {value}.",
            "required_unless": "Поле {attribute} є обов’язковим, якщо {other} не дорівнює {values}.",
            "required_with": "Поле {attribute} є обов’язковим, коли вказано {values}.",
            "required_with_all": "Поле {attribute} є обов’язковим, коли вказані всі {values}.",
            "required_without": "Поле {attribute} є обов’язковим, коли не вказано {values}.",
            "required_without_all": "Поле {attribute} є обов’язковим, коли жодне з {values} не вказано.",
            "same": "Значення {attribute} повинно збігатися з {other}.",
            "size": {
                "numeric": "Поле {attribute} повинно бути розміром {size}.",
                "file": "Поле {attribute} повинно бути розміром {size} кілобайт.",
                "string": "Поле {attribute} повинно містити {size} символів.",
                "array": "Поле {attribute} повинно містити {size} елементів."
            },
            "string": "Поле {attribute} повинно бути рядком.",
            "timezone": "Поле {attribute} повинно бути дійсною часовою зоною.",
            "unique": "Значення поля {attribute} вже використовується.",
            "uploaded": "Не вдалося завантажити файл у полі {attribute}.",
            "url": "Поле {attribute} має неправильний формат.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "email": {
                    "unique": "Ця електронна адреса вже зареєстрована."
                }
            },
            "attributes": {
                "email": "електронна пошта",
                "username": "ім’я користувача"
            }
        }
    }
}
